module.exports = {
  "Gattaran_optimization_yGvp_jOAe": "确认",
  "Gattaran_form_tLLN_yhWQ": "我们将自动填充经常使用的联系人信息，你可以点击编辑内容",
  "Gattaran_V1__YaIb": "在线",
  "Internal_Tools_0523_GtzK_ZoJh": "该商家当前无符合条件的活动，请引导商家参加自营销活动",
  "FoodOpB_Translation_Maestra_Accounts_ktyA": "Maestra accounts",
  "FoodB_0617_DewC_iPTt": "竞对日完单量-R",
  "FoodOpB_management_Special_rules_PdhA": "特殊规则",
  "FoodB_up20241218_aEPD_NaLf": "选择菜品",
  "FoodB_Commision_Add_MPEf": "添加",
  "FoodC_202408_wten_GUVt": "选择收餐地址",
  "FoodB_calculator_CXvv_RJgQ": "税和佣金前的应收金额",
  "FoodB_tagging_You_chose_OMGB": "您选择了无效商机原因为：店铺不存在，必需填写照片！",
  "FoodB_calculator_gRHL_Sgok": "利润率",
  "FoodB_collection_11_digits_QhYs": "11位数字，不能有空格",
  "FoodOpB_management104_Coordinator_endx": "协调员",
  "Help_V4_Enter_the_xqlm": "请输入正确的手机号",
  "Internal_Tools_CRM_afvI_xcXS": "仅支持尺寸为750*360px的图片",
  "Gattaran_transformation__TnQQ": "关联新签约主体",
  "Gattaran_merchantfee2_sTmZ_koaw": "输入值不能小于{{min}}",
  "FoodB_0_Please_upload_ziBz": "请上传通话记录截屏",
  "FoodB_phrase__NpWx": "仅展示近{{number}}个月的已结束营销活动",
  "FoodOpB_1_Expired_rTXx": "已过期",
  "FoodB_202303_YWUL_hwNF": "好的",
  "FoodB_page_aMFR_fMYY": "录音上传失败",
  "FoodC_Storefront_iOFy_aaef": "商家暂未参与活动",
  "FoodB_0617_pLtb_hIQz": "竞对日完单量-U",
  "Gattaran_0_Clerk_tends_QpMA": "店员倾向联系方式",
  "FoodB_Show_Store_Direct_GuJM": "商户直签",
  "FoodOpB_Management_Appeals_foxk": "申诉",
  "FoodB_optimization__bdZL": "请上传5M以内且不小于200*200的图片，支持jpg、png格式。",
  "Gattaran_management_NjMN_zyWQ": "已计划·{{date}}",
  "soda-c-i18n---个人中心的“优惠券”": "个人中心的“优惠券”",
  "FoodB_1106_FGdT_UxXY": "AI总结生成中",
  "Gattaran_opt_swMT_sNcV": "营销-套餐",
  "Gattaran_20240401_rbqe_PoaI": "该问卷必须填写",
  "FoodC_sales_Confirmation_mTGd": "确认",
  "FoodOpB_v2_Data_update_YmPK": "数据更新时间",
  "FoodB_v1_Sources_of_DsXR": "信息来源",
  "Gattaran_transformation__LMJQ": "主体已签约。追加门店请在加塔兰后台完成",
  "soda-c-i18n---现金": "现金",
  "FoodB_202502_ldlj_sqzT": "提交",
  "Internal_Tools_App2_HwDq_KOci": "周二",
  "Internal_Tools_App_Bruh_XLwk": "周环比率",
  "Internal_Tools_App2_wNPW_VZxE": "市场零售价",
  "FoodB_1__gcdX": "活动数据",
  "FoodD_payout_Account_Type_YmVW": "账户类型",
  "Gattaran_statusbar2_eoSG_yEDD": "已核准",
  "Gattaran_record_IcKI_Jklz": "编辑拜访",
  "Gattaran_84_iOCg_cQuB": "违规详情",
  "FoodB_email_CBNM_cSdr": "邮箱",
  "FoodB_V2_Illegal_companies_pXwb": "非合法公司",
  "FoodOpB_1_New_visits_HXsz": "新建拜访",
  "FoodB_opencheck_LMsZ_xcHH": "已完成",
  "FoodB_accompanyvisit_WSQI_ySkV": "BD是否明确了解本周目标与工作重点？",
  "FoodC_sidebar_Use_the_huoZ": "使用APP，随时随地享有美食",
  "CS_Aftersale_Wrong_meal_gNCe": "错餐",
  "FoodB_management_Automatic_Switching_ghJS": "自动开关店",
  "FoodC_education_3_If_wduh": "3. 若因产品问题、天气问题等非人为因素导致交餐纠纷，平台承担责任",
  "FoodB_opencheck_RrIx_AlOc": "请确认头图合理美观，在用户端展示无误",
  "FoodB_scenario_UTGm_CSqz": "自配送履约超时",
  "Gattaran_202406_eUIt_lfFS": "已完成",
  "Gattaran_url_nvGh_CcGr": "链接请以 http://或https://开头",
  "Gattaran_feedback_pIVP_WMGv": "提交成功",
  "Gattaran_0__Yqcw": "当前区域没有门店",
  "FoodB_Translation_fqel_jrJX": "补充证明图片（可选）",
  "FoodB_communications_nVMa_oikA": "新店成长",
  "FoodB_opencheck_elIB_jhlk": "请确保地址信息及定位与实际门店地址一致",
  "FoodB_audit_Store_Information_ryuV": "门店信息编辑审核",
  "Gattaran_form_xrZg_zpSi": "结果",
  "Fintech_Credit_part__mMjm": "筛选项",
  "FoodC_202410_ZHQi_kNsP": "修改",
  "FoodC_c_Completed_djPp": "已结束",
  "Gattaran_0516_AZMU_LSZh": "签约门店数",
  "FoodB_page_Zytk_sRrm": "录音上传中",
  "FoodB_list_Recently_launched_IWDa": "最近上线时间",
  "Gattaran_add_vitO_CCPh": "Picture coverage>=60%",
  "FoodB_Contract_CqnW_XWkx": "签约协议中的佣金补贴",
  "FoodOpB_1_Seven_days'_LZwW": "七日拜访",
  "FoodC_202408_qXNe_iBNs": "获取当前位置失败",
  "更多": "更多",
  "FoodB_APP_cmsF_AWtY": "未开始的活动",
  "Gattaran_202406_lujp_fWRq": "任务描述",
  "FoodB_1__IhgO": "更新至:{{time}}",
  "FoodB_0617_EuIs_mugQ": "餐厅每天通过“送货上门”的方式处理多少份订单？",
  "Gattaran_0__VRqN": "已加载全部门店",
  "FoodOpB_1_Close_visit_ttxh": "关闭拜访确认",
  "Gattaran_side__MIpl": "星期五",
  "FoodC_Website_From_shop_Jatv": "从【shop name】点外卖，立刻下单|DiDi Food",
  "Gattaran_optimization_oRge_RkDM": "拜访任务完成度·{{month}}",
  "Gattaran_Optimization_zZhD_VHmE": "点击查看商家地址并支持导航",
  "FoodB_SMS__promotion_EKZy": "免配送",
  "FoodB_V1_oOpd_aRtv": "未完成",
  "FoodB_up250108_BLxC_rIzf": "稍后查看",
  "Internal_Tools_App_CwAV_dUXQ": "反馈",
  "FoodC_202412_DMKw_kWMA": "试试搜索建筑物、街道和门牌号",
  "FoodB_1106_fJJY_Hpvo": "重新录入",
  "Gattaran_visit_zdKK_wwRk": "拜访结果",
  "Gattaran_opt_cWad_xQOF": "问题订单",
  "FoodB_audit_Review_process_vGtV": "审核流程，是否确定？",
  "FoodB_page_hrsd_hBdh": "确认要退出吗？退出后上传结果将不会保存。",
  "Gattaran_84_fQos_Hkqg": "提醒",
  "FoodB_page_bkdh_cEvr": "录音",
  "FoodB_in_WoaK_VhQt": "确认",
  "FoodC_20240607_ffiX_wNQG": "WhatsApp",
  "FoodB_20250122_FReB_KjrR": "任务完成人",
  "Gattaran_20250610_NTRi_nVIB": "去RTBO",
  "FoodB_collection_idCIF_qqcc": "idCIF",
  "FoodB_IGV_iopU_urly": "增值税税率",
  "FoodB_calculator_vEpj_lLGl": "总折扣",
  "FoodB_feedback_mdHs_sFsm": "反馈详情",
  "FoodB_0_WhatsApp_dmMD": "WhatsApp",
  "FoodD_Name_October_WGkU": "十月",
  "FoodC_202412_QJMa_Qkwg": "输入并添加新的配送地址",
  "Gattaran_opt_RltV_fDyM": "特价餐(非套餐）",
  "FoodB_document_vGTm_pEcu": "上传文件不能超过{{limit}}MB，请重新上传",
  "Internal_Tools_App_wlIb_LduM": "油站电话",
  "FoodB_Show_Tax_payment_xfxh": "纳税方式（全国）",
  "Gattaran_Visit_Visiting_Process_KFJZ": "拜访过程评分",
  "FoodB_V1_uXrr_bWox": "你可以在此管理或重置筛选项",
  "FoodB_opencheck_gjbJ_NUmG": "营业时间",
  "FoodB_indicator_jKXT_ctMP": "指标含义",
  "确认": "确认",
  "FoodB_communications_HAnw_bYAw": "门店有未完成任务",
  "FoodC_education_3_Customers_Zoec": "3. 顾客需要保持手机畅通，便于骑手联系取餐；",
  "Gattaran_KPI4_Sjnd_VzaZ": "商家提醒",
  "FoodB_1106_tawV_utGy": "下一步计划",
  "Gattaran_function__iTSm": "版本",
  "FoodB_list_B_Burn_LIiU": "B2C burn / GMV",
  "FoodC_202412_kamX_bNUi": "请选择要添加的地址",
  "FoodC_20240607_fIqe_iMtS": "接受",
  "FoodB_2_Store_XkLQ": "商家",
  "FoodB_0622_Select_up_QXDl": "最多选择2个门店",
  "FoodB_1106_isfE_qwXl": "语音文件上传中，请勿离开该页面",
  "FoodC_edit_NDmM_lEJY": "请在门口见面",
  "FoodC_202408_HfXO_xbcw": "查看",
  "Gattaran_202406_jhpc_QSnv": "参考信息",
  "FoodB_tagging_You_chose_aZCG": "您选择了无效商机原因为：停止营业，当前位置距离店铺大于{{distance}}，请检查！",
  "Internal_Tools_App_zuDQ_HAZF": "请输入数字，小数点后限两位",
  "FoodB_in_RMIn_GztT": "签退失败",
  "FoodB_accompanyvisit_xZuc_foEH": "描述BD在接洽中是如何自我定位的：是否展现出同理心、主动倾听能力以及与客户建立真诚的联系？",
  "FoodC_education__1_vwgm": "（1）送货上门",
  "Gattaran_management_sGBh_ExWD": "营业时间",
  "FoodB_resivion_Feedback_to_QmQU": "请反馈给你的上级进行更新",
  "FoodB_task_BFBu_ONmI": "任务未执行",
  "FoodB_0926__Jfhv": "无相应状态的营销活动",
  "Internal_Tools_App_vLxA_pkbn": "添加图片",
  "FoodB_0617_qpbP_bnWv": "自配送日完单量",
  "FoodC_perception_Tips_hZWk": "小费",
  "Gattaran_0410_hDTJ_vhKk": "点击此处查看绩效详情",
  "FoodB_0907__jtsj": "无诊断内容",
  "Gattaran_status_jQaO_nxvn": "跟进状态",
  "FoodB_20250122_IbZs_wRcg": "任务创建后X天未完成再下发",
  "Gattaran_0_Need_to_uMbb": "需要与KP确认",
  "FoodB_group0901_tZIs_QwiK": "提名",
  "Gattaran_Visit_Evaluation_eRDU": "自我评估",
  "Gattaran_V2_TPLj_miRJ": "商家列表",
  "FoodC_optimization_rmLx_bSmk": "请搜索并添加您的见面地址",
  "Gattaran_optimization_mtXy_iWsc": "最少选择2个选项",
  "Internal_Tools_App_qYbb_MgvG": "系统异常，请稍后重试",
  "Gattaran_0_Salesmen_tend_hFQf": "店员倾向联系时间",
  "FoodB_Show_Foreign_DIMEX_LKxF": "外国人DIMEX",
  "FoodC_education_Meal_picking_ziun": "取餐规则",
  "Gattaran_subsidy_wnTI_MvfU": "该主体已签约独家且带有佣金补贴策略，不可新增！",
  "FoodB_management_sgrl_Drgj": "其他",
  "Gattaran_0_Agree_gCQO": "同意",
  "FoodC_revision_Contact_customer_XbFk": "联系客服",
  "Internal_Tools_App_mZpF_DDAl": "价格趋势",
  "FoodB_in_zsVG_TNBT": "该店铺当日已完成过签到，确认再次打卡么？",
  "FoodB_1106_UJYm_mRFD": "您可以编辑AI分析生成的内容，并在确认后提交最终记录。",
  "FoodC_shop__hSnf": "该商品库存仅剩{{num}}份",
  "Internal_Tools_App_vFxG_UzcO": "线索状态",
  "FoodOpB_Management_High_similarity_lnFn": "存在高相似度店铺",
  "FoodB_Launch_DR_Passport_JChW": "DO-护照",
  "Gattaran_Visit_Change_1_LYvR": "改变1",
  "FoodC_202410_mjfG_DDhf": "添加",
  "FoodB_opencheck_hHbN_hIdN": "请确认商户菜单创建完成：品类正确、价格符合平台标准、用户端展示无误",
  "FoodB_0905__yxOa": "与上一统计周期相比，单量不变",
  "FoodC_improvement_Rgol_abYw": "您已提交取消申请，商家最晚将在{{XminYs}}内处理，请您耐心等待。",
  "FoodB_survey_IQBT_jfZq": "竞对独家合同到期日期-P",
  "Gattaran_v1_Whrf_ZdCg": "未报名，请前往商家平台进行操作",
  "Gattaran_0_Is_the_dYmK": "商家菜单是否易读",
  "FoodB_feedback_LZDo_DoVn": "建议与反馈",
  "Internal_Tools_App_qWbF_LiGR": "位置校准",
  "Internal_Tools_App_kqPi_MVIx": "提示",
  "Gattaran_Homepage__bYLT": "首页",
  "Gattaran_0_The_end_KvBf": "结束时间必须大于开始时间",
  "FoodB_B86_bcPL_fkRh": "历史问题",
  "Gattaran_visit_Wpaf_mvuG": "BD成功达成了协议",
  "Gattaran_Top_Qwud_sgUf": "2.系统每月2号和17号会刷新一次商家的DiDi Top标识",
  "Internal_Tools_App2_VFPY_BWgZ": "周日",
  "Gattaran_84_RhFf_bZsT": "违规类型",
  "Groceries_shop2_Fwyu_yymq": "抱歉，您最多可加购{{num}}个商品",
  "FoodB_page_kKLt_Kkxo": "拜访方式",
  "FoodB_1106_vPRw_ajcX": "是否确认删除已录制内容？",
  "Gattaran_AlertV1_ADYi_okAH": "知道了",
  "Gattaran_V1_DJia_IZfI": "完成度",
  "FoodB_in_pytn_Fsdo": "您距离{{storename}}超过{{distance}}米，无法签退。可通过拍摄您和商家门牌的合影完成签退。",
  "FoodB_indicator_WkbT_GJnu": "得分规则",
  "FoodB_scenario_ShEY_kNaS": "因停水/停电等意外无法出餐",
  "FoodB_0_SMS_yOMB": "短信",
  "Gattaran_0_KP_Tendency_hgOB": "KP倾向联系时间",
  "FoodB_opencheck_jhOc_eZOf": "该商家存在单日低于2小时的营业时间，是否确认正确并继续提交？",
  "FoodB_opencheck_TrQs_xHIv": "您已完成该商家全部二次检查信息确认，全部信息将进入人工审核阶段，一经发现作假行为，将会对您绩效产生不良影响",
  "FoodC_payment_eCqh_ogxh": "当前暂不支持线上支付，敬请期待！",
  "FoodB_survey_xyMR_sTst": "是否在竞对独家-P",
  "Gattaran_subsidy_tyxq_WwhG": "新增佣金补贴",
  "FoodD_Name_February_bMVM": "二月",
  "Gattaran_addded_wrMT_Smyq": "提前结束活动",
  "FoodC_202410_Ejdi_makf": "选择店铺",
  "FoodB_list_Name_of_dxYm": "销售姓名",
  "Internal_Tools_App_wjZO_XKBK": "近{{week}}周",
  "Gattaran_REGULAR_UodO_bJVP": "请在100内填写",
  "FoodC_202408_Jvou_Cqor": "附近位置",
  "Internal_Tools_App_OMWw_QlWM": "激励中",
  "Gattaran_V1__ZtqD": "查看营销教程",
  "soda-c-i18n---送您1张%s优惠券；": "送你1张%s优惠券；",
  "Gattaran_202406_WOhb_WMrp": "你好，你收到了高优先级的的相关任务，请查看",
  "FoodB_20250122_aETX_fsRi": "天",
  "Internal_Tools_App_MIpi_aqcx": "我的油站",
  "FoodB_Contract_QbrO_gJzi": "签约协议中的佣金补贴{{unit}}{{number}}%",
  "Gattaran_opt_ZoVs_IpEA": "支持发起签约、查看签约状态、查看失败原因等",
  "FoodOpB_management_Indicators_BzjD": "指标",
  "Gattaran_visit_CRcg_FwpW": "否",
  "Gattaran_management_wjiE_tOBX": "你好，{{name}}。随函附上访问期间达成的协议摘要：",
  "FoodB_20250414_zXUI_rXee": "商家补贴",
  "FoodB_process_FzSw_LUcq": "RTBO进度",
  "Internal_Tools_App_cuEn_PzWj": "编辑导航地址",
  "FoodB_accompanyvisit_yiVS_jbCk": "请描述BD在整个陪访中的态度：即使面对挑战，是否始终保持专注、积极主动和专业素养?",
  "FoodD_AccountInfoCollection_Got_it_QvNt": "知道了",
  "Gattaran_Visit_Formula_pre_iaaI": "公式=（准备工作评分+拜访过程评分+拜访后评分）/3*100%",
  "FoodB_Dimension_UVvy_UnnT": "客单价",
  "Gattaran_Top_pXow_LHcq": "1.当商家“完单量”“B责取消率”“用户评分”达到一定标准（不同城市标准不同，详见商家详情页面），则商家会被识别为DiDi Top",
  "Gattaran_Optimization_WwkH_amBP": "点击可以查看更多联系人，并拨打电话",
  "FoodC_optimization_GUGp_fDxe": "返回上个页面",
  "FoodB_Launch_DR_Temporary_BQFH": "DO-临时居留证",
  "FoodB_0830__BIGT": "本月拜访次数",
  "FoodB_time_No_permission_Xxyy": "无权限",
  "Internal_Tools_App_Rmvn_wSCd": "油站ID",
  "FoodC_remark_Thank_you_ENoY": "感谢您使用{{brand_name}}服务",
  "FoodOpB_1_Information_gathering_pIHo": "信息收集",
  "Gattaran_V2_mEQa_FFuE": "任务详情",
  "FoodC_dish_Current_activity_Iyrv": "当前活动将在{{arrived_time}}后结束，结束后您将无法购买新人专享特价菜品",
  "FoodB_in_Nxye_qBAZ": "返回",
  "FoodB_20250414_uqsI_JhAj": "P1",
  "FoodB_email_mlcn_NvDS": "倾向联系方式",
  "soda-c-i18n---晚间：%s-%s": "晚间：%s-%s",
  "FoodB_Validation2_UJDi_eBej": "首尾不能包含空格",
  "FoodB_2_Online_visit_OLuR": "线下",
  "Internal_Tools_0510_EoqC_dJrN": "未设置营业时间",
  "FoodC_202410_YFVb_hzJK": "没有地址，点击添加",
  "Gattaran_V1__WcTv": "菜品合格率",
  "FoodB_model20250116_iVfy_zMbV": "签到成功",
  "FoodOpB_1_Visit_Details_fMYD": "拜访详情",
  "FoodOpB_results_No_key_kUbv": "无关键目标联系方式",
  "Gattaran_opt_ybdn_zFnD": "电话信息缺失，待补充",
  "FoodB_0919__flip": "上架菜品数",
  "FoodB_0617_Blon_MRMe": "到店自取日完单量",
  "FoodB_audit_Audit_process_asoS": "审核流程，且在审核完成前不可申请签约，是否确定？",
  "FoodB_accompanyvisit_KOZp_Nkwc": "是否能够识别主要痛点并有针对性地引导提案？",
  "FoodB_calculator_dsiQ_vhFJ": "应收金额",
  "Internal_Tools_App_pFzG_uAQv": "该线索已失效",
  "FoodC_202409_dTTH_bjFQ": "该订单已完单或不存在，无法查看",
  "FoodB_V1_tdXj_tAvG": "商家任务",
  "Gattaran_202406_JcEF_NsbI": "商家名称",
  "FoodB_1106_qUmr_XNmN": "录音上传失败",
  "Gattaran_visit_PQZP_gcOK": "是",
  "Internal_Tools_App2_xWJN_ZxWx": "计划删除后将无法恢复",
  "Gattaran_Collection__cRDE": "最近搜索",
  "FoodC_Website_At_present_XpFw": "目前Web站暂未上线兑换功能，请前往App端进行兑换码兑换",
  "FoodB_202204_Number_of_yYUn": "差评订单数",
  "Gattaran_0_Add_Image_xyvl": "增加图片覆盖",
  "Gattaran_MSGCenter__JYjL": "请输入",
  "FoodC_edit_bZFb_ghVG": "请在酒店楼外见面",
  "FoodB_email_KYaO_tHVJ": "App操作员",
  "FoodB_Show_Savings_uvSS": "储蓄",
  "Gattaran_opt_aDBh_QgeX": "开店检查项",
  "FoodB_Sales_NPeL_QUgG": "收起",
  "Gattaran_subsidy_rKRR_cLtu": "该主体已存在佣金补贴策略，是否进行替换？",
  "Gattaran_form_hRvn_xomV": "电话是必填的",
  "FoodOpB_1_Visiting_hours_yAJS": "拜访时间",
  "Gattaran_84_FlDC_sTHq": "其他平台在线时间：",
  "FoodB_leads_Artificial_labcategory_UNzu": "人工标记品类",
  "FoodD_supplement_Small_time_ycjv": "小时",
  "Internal_Tools_App_csEG_rLit": "油站税号",
  "FoodB_opencheck_LSiU_XQss": "商家出餐时长",
  "FoodB_list_Store_ID_GNUR": "门店ID",
  "Gattaran_0__EDtg": "开启",
  "Internal_Tools_App2_PcSB_DsIH": "周三",
  "Gattaran_0_App_Opertends_voML": "App操作员倾向联系方式",
  "FoodB_system_offline_revV": "线下",
  "FoodB_address_Submission_cfyI": "提交",
  "FoodOpC_Notifications_Are_you_DIlk": "是否确认删除？",
  "FoodOpB_manage_Details_IfVh": "详情",
  "FoodB_0926__bEjZ": "无未开始的营销活动",
  "FoodB_Side_HjnR_pape": "销售",
  "FoodB_CL_Individuals_VUHt": "个人",
  "FoodB_reason_Contact_Courier_Fqog": "联系骑手",
  "Gattaran_202406_REeT_tgTh": "任务维度",
  "FoodB_list_Brand_Name_pGTc": "品牌名称",
  "Gattaran_transformation__IetC": "创建新签约主体",
  "Gattaran_optimization_dYfW_WtFS": "完成度",
  "Gattaran_management_LaXK_Gsyq": "我的拜访",
  "FoodB_1106_LrXH_ibej": "正在为您生成AI总结，预计需要1~5分钟完成，点击关闭不会中断总结的生成，生成完成后您可在商机详情页的跟进信息中查看。",
  "FoodOpB_management_Actual_integral_xbDD": "实际积分",
  "Gattaran_optimation_Gchd_SmWz": "忽略",
  "FoodB_process_xaxm_WPYE": "待RTBO",
  "Gattaran_opt_dswD_GkVn": "拜访信息",
  "Gattaran_Optimization_Gbsd_oiSb": "门店PK",
  "FoodC_202408_SXSA_LasS": "绑定手机号，享受更多权益",
  "FoodB_0905__qppX": "与上一统计周期相比，减少{{number}}单",
  "Gattaran_management_yrfV_Wxnn": "过期拜访·{{num}}",
  "FoodB_V3_XLPv_RMTE": "去处理",
  "FoodD_Name_December_Ykas": "十二月",
  "Gattaran_REGULAR_bTIM_MAXe": "请在1000内填写",
  "Internal_Tools_App2_ZJkV_KWsU": "过期拜访·{{num}}",
  "FoodB_process_xsHa_ISXI": "整改成功",
  "FoodB_opencheck_lCvT_CpyN": "一店多开集成接单配置",
  "Gattaran_jumpnewstore_mLmx_PSph": "完成新成长任务，获得额外流量",
  "Gattaran_0516_bxzD_gtXp": "关联门店数",
  "FoodD_Compliance_About_to_fTcV": "即将过期",
  "FoodD_Name_June_sECU": "六月",
  "FoodB_in_sHcD_gWZN": "拍照",
  "Gattaran_opt_hEOr_vnKB": "点击编辑商机基础信息",
  "FoodB_in_gwvR_PqVc": "请到移动端拍照上传照片",
  "Internal_Tools_0523_RFQp_wVYb": "可注册",
  "FoodB_in_TaxL_JViY": "无打卡记录，拜访时间需关联打卡记录",
  "FoodB_opencheck_LMWw_Ntdr": "未完成",
  "FoodB_model20250116_dVSj_sFUN": "待审核",
  "Gattaran_side__EEqj": "星期六",
  "FoodB_page_FeSg_DGnj": "录音内容",
  "FoodB_opencheck_LuWf_IQwZ": "请完成呼叫后再完成确认",
  "FoodB_page_DaRX_EbCh": "一键填入表单",
  "Gattaran_Visit_jKcM_bAxG": "达成交易",
  "Gattaran_url_Myae_HenA": "系统抓取的{{Uber}}菜单链接",
  "Gattaran_Process20250815_FAmy_CJIx": "佣金申请不通过，可修改后再次提交",
  "Gattaran_0_Name_of_ZnnR": "店员姓名",
  "Gattaran_management_pWnp_hrQt": "概要",
  "FoodB_V1_DoLm_HYBb": "未开启",
  "FoodB_opencheck_MGuv_oPMp": "请检查{{99store}}打印机配置是否正确，小票能否打印及备注是否清晰",
  "FoodB_V1_FPpu_unON": "上传堂食菜单",
  "Gattaran_20240401_CGBK_NFyI": "必填问卷",
  "FoodOpB_Translation_Foreigner_hMcE": "外国人卡",
  "Gattaran_0_App_operators_aRSs": "App操作员倾向联系时间",
  "FoodB_1106_XQNm_orQN": "核心进展/客户需求/关键问题是什么？",
  "帮助中心": "帮助中心",
  "Internal_Tools_App_ttnY_JnyP": "主要联系人已更新",
  "Gattaran_optimization_TyQA_JkkG": "刷新",
  "FoodB_0919__RZJo": "正常完单数",
  "FoodB_Optimization_alYq_lLkr": "商机门脸照片",
  "Gattaran_form_JZlB_BGSo": "请输入真实原因",
  "Gattaran_feedback_IzpJ_EtUe": "选择任务无法完成的原因（必填）",
  "FoodC_web_Only_1_ZddK": "仅限1件",
  "Gattaran_management_SBaW_IDnY": "邮件详情",
  "soda-c-i18n---将赔付给您%s张免配送费券": "将赔付给你%s张免配送费券",
  "FoodB_process_IUdd_MmbJ": "申诉成功",
  "FoodB_accompanyvisit_IwGb_xDta": "是否做了充分的市场调研，根据合作伙伴的实际情况提出精准的探询性问题？",
  "FoodB_1106_vAhW_qNLK": "重新录制",
  "FoodD_accept_vrSy_OJYX": "自动接单",
  "Gattaran_opt_SrLe_Wnrt": "较上期减少{{change}}",
  "Gattaran_V2_aXUA_FYif": "请输入任务名称",
  "FoodB_opencheck_zmzr_ekYy": "门店头图",
  "Gattaran_202311_qwtt_tkJb": "已筛选出Hotlist的门店，请高优跟进",
  "Gattaran_address_WKng_Kgqu": "相同地址门店",
  "Gattaran_management_iAiq_CSuB": "已有相同时间计划，请直接编辑",
  "FoodD_Name_March_cqIc": "三月",
  "Gattaran_form_UTaZ_WTAv": "信息尚未保存，确认要离开吗？",
  "FoodB_opencheck_qYIq_JnQa": "门店名称",
  "FoodC_education_2_If_SoSk": "2. 若骑手未按照平台规范完成交餐，导致交餐纠纷，优先骑手承担责任",
  "FoodC_education__unk_aOCD": "{{delivery_type}}平台规则",
  "Gattaran_Visit_Please_choose_kUmR": "请选择被陪访人",
  "FoodOpB_app_Need_for_inMl": "需要进一步谈判",
  "FoodB_calculator_UUgW_xBLd": "菜品数量",
  "小费": "红包",
  "Gattaran_V1__ccGl": "过去30天",
  "FoodB_Part1_Store_Name_jrHD": "门店名称",
  "Internal_Tools_App_rdCa_GHLw": "纬度：{{lat}}",
  "sailing.crm-intl.普通": "普通",
  "FoodC_education__2_jwSo": "（2）放在门口（文字备注）",
  "FoodD_page_Manual_Accept_jCTW": "手动接单",
  "Internal_Tools_App2_VhOQ_uUiq": "目的：{{objective}}",
  "Internal_Tools_CRM_hPLY_Zkpg": "集团",
  "FoodB_1106_EwXU_HfGg": "您做了什么工作？",
  "FoodB_Show_Subject_Information_RFOj": "主体信息",
  "FoodB_indicator_vrlT_COvu": "数据范围",
  "Gattaran_0__dPUc": "最多加载{{amount}}家门店，点击查看更多",
  "FoodB_v4_QCuD_iNCy": "完成拜访后需正确填写拜访对象信息",
  "Gattaran_opt2_aPIx_GJQw": "营业平台",
  "FoodB_accompanyvisit_nTXs_ubxz": "评论一下BD是如何为陪访工作做准备的：是否目标明确、有效使用了CRM系统，以及是否在拜访中保持了战略聚焦？",
  "Gattaran_0_Remind_store_lgTS": "提醒商家上线",
  "FoodB_0920__QnBO": "不满足诊断规则",
  "Gattaran_transformation__LRHh": "关联已有签约主体",
  "Gattaran_opt_XUCE_CQDw": "编辑线下经营信息",
  "FoodOpB_10_Order_volume_WNmq": "订单量",
  "FoodB_resivion_Skip_qpSD": "跳过",
  "Internal_Tools_App2_aAXv_aRlS": "区域{{number}}",
  "Internal_Tools_CRM_NNrK_cPfT": "营业时间",
  "FoodB_model20250116_IADF_eXfa": "签退",
  "Gattaran_0_Promotional_materials_vvdT": "宣传材料",
  "FoodOpB_CRM_Card_holder_NfIL": "持卡人证件号码",
  "Internal_Tools_App_enKj_BRtS": "价格",
  "FoodB_20250414_qQjO_NTiY": "时间线",
  "FoodB_Translation_CHLm_cImn": "申诉理由",
  "FoodB_sob_tNpJ_cGze": "提示：{{shopname}}一旦与该手机号绑定，那么商家使用该手机号登录SOB官网可查询到该门店并且继续完成入驻流程。后续无法修改绑定手机号，请谨慎操作",
  "FoodB_email_Lqnd_eyfn": "协议和评论",
  "Internal_Tools_App_oOXF_fLkh": "确认",
  "FoodB_process_URNV_nSAi": "审核通过",
  "FoodC_202410_SiDC_Empm": "立即点餐",
  "Gattaran_status_nmHO_eiGS": "待攻克",
  "FoodB_I_UlHM_KKLT": "活动订单量",
  "FoodC_optimization_RLDn_cLAQ": "请添加见面地址",
  "FoodB_page_bAZB_UbSa": "上传语音文件",
  "FoodB_APP_QiyP_UysU": "ASP",
  "FoodB_sob_ywDb_qwVV": "绑定账号后告诉商家使用该手机号通过SOB官网进行签约",
  "Gattaran_0__sGZg": "欢迎给我们分享关于Explorer的反馈。",
  "Internal_Tools_App2_TIxP_DqBp": "备注",
  "FoodB_Show_Aliens_Residence_creU": "外国人居留卡",
  "FoodC_sales_Condition_of_lnwg": "收餐时外包装密封品状态（必填）",
  "Gattaran_Optimization_PLZM_XBgE": "点击跳转DiDi Food到商家页面",
  "Internal_Tools_App_Mldc_EJhb": "更多",
  "分钟": "分钟",
  "Internal_Tools_App_mKHz_CpID": "获取当前位置经纬度",
  "FoodB_2_R_Burn_AyGL": "R burn/ GMV",
  "Gattaran_V1_MQcd_ixfe": "查看全部可报名的商家",
  "FoodOpB_app_Need_to_eGSb": "协商SUP",
  "FoodB_accompanyvisit_YSoL_pTLj": "规划与准备",
  "FoodB_accompanyvisit_oTmI_wmHE": "是否能根据餐厅现状和决策者特点，建立真诚（默契）的信任关系？",
  "FoodC_202412_SxTA_sqKU": "附近地址",
  "Gattaran_REGULAR_luKX_QwKw": "墨西哥税收Input",
  "FoodB_0905__ccXH": "诊断周期",
  "FoodC_remark_Enjoy_your_OvmD": "祝您用餐愉快",
  "Gattaran_0__XIOS": "请输入店铺数量",
  "Gattaran_form_zKmF_tGJc": "确认",
  "FoodB_opencheck_KYqZ_ipBk": "确认门店营业时间合理正确，明显不合理营业时间需与商家再确认。错误示范：每天营业时间过短（<=2小时）或营业时间集中在半夜（1:00～4:00）",
  "Gattaran_cancelation_CSTW_mefB": "任务已执行",
  "Gattaran_jumpnewstore_UjqV_XVxm": "新店成长",
  "Gattaran_202311_NpGG_CLsO": "返回距离该门店{{distance}}内的结果",
  "FoodC_reasons_Enter_a_Pnzg": "请输入具体原因",
  "FoodB_V1_Yqgj_TuBe": "已过期",
  "Gattaran_optimation_shNo_Pflo": "拜访表单页面意外退出，点击“重新打开”以再次进入上一次停留的页面。",
  "FoodB_calculator_hmWL_DEwB": "否",
  "FoodC_20240607_IbZr_cIyA": "请检查店铺链接后重试",
  "Internal_Tools_App_vOMm_KIrz": "退出登录",
  "MRider_Version_payment_method_rQSI": "支付方式",
  "FoodB_0617_Bibj_VmDq": "竞对营业平台",
  "Gattaran_function__Comd": "更新内容",
  "FoodB_Upload_qSTm_LkAc": "堂食菜单",
  "FoodC_education__4_QYXm": "（4）顾客拒绝支付现金单",
  "FoodB_V2_No_bank_plEI": "无银行账号信息",
  "FoodB_Show_Final_Tax_XQQi": "最终缴税金额",
  "FoodB_opencheck_PWFs_yYqE": "上线&接单",
  "FoodC_education__3_ltNM": "（3）因分配不到骑手等平台原因或外部原因导致订单取消的情形",
  "FoodB_model20250116_QHad_xAWm": "拜访类型",
  "Gattaran_jumpnewstore_WVcO_LmBU": "详情查看",
  "Gattaran_add_XrAW_datb": "Available dishes>=5",
  "FoodB_up20241218_ZADd_MrpU": "选择最少一个最多5个菜品，不可选择酒水饮料等",
  "Gattaran_management_DvoF_BCCh": "拜访任务",
  "FoodOpB_CRM_Type_of_fbmW": "持卡人证件类型",
  "Gattaran_status_NNzP_nKcZ": "待完成开店检查项",
  "FoodB_Contract_YYIE_YBzS": "是",
  "Gattaran_Collection__YHYF": "推荐",
  "FoodB_V2_Failure_to_sQaD": "未达合作门槛",
  "FoodC_edit_fOqC_upyr": "在大厅见面",
  "FoodB_accompanyvisit_ucKi_dFmF": "请描述BD在整个陪访中的态度：即使面对挑战，是否始终保持专注、积极主动和专业素养?",
  "FoodB_20250612_vHLr_wHDi": "WhatsApp号码",
  "FoodB_Show_Tax_payment_Dbuz": "纳税方式（当地）",
  "Gattaran_transformation__PgJQ": "主体信息",
  "FoodC_202410_KMCG_kJBn": "切换",
  "FoodB_calculator_pQIn_LdhF": "是否RFC有效",
  "Internal_Tools_App_AsKa_smrq": "选择油品种类",
  "FoodOpB_Translation_BD_with_Jqpl": "BD与餐厅门脸合影",
  "Gattaran_20240902_AmRI_DoWJ": "驳回原因",
  "Internal_Tools_App_TwQH_yOgX": "分行",
  "FoodC_all_No_reward_ocGJ": "没有奖励",
  "FoodB_0622_Contrast_jVys": "对比",
  "FoodOpB_Translation_Enter_CCI_YyDK": "请输入CCI账号",
  "FoodOpB_CRM_Taxpayer_full_tMpR": "纳税人全名（当地）",
  "Internal_Tools_App2_GYGq_FzxS": "当日线下拜访计划超过{{number}}条，将默认为你选择前{{number}}个待拜访计划生成路线",
  "FoodB_communications_BCnM_evHy": "门店本周有新店成长任务到期",
  "FoodB_APP_rOdA_ZxIz": "智能营销",
  "Gattaran_v1_HLQw_cJDz": "点击展示具体商家经营时间明细",
  "FoodB_supplement_No_data_jUGB": "没有数据",
  "Gattaran_limit_NvlC_czdh": "无权限，仅门店负责销售可操作",
  "FoodB_Contract_fYLE_mfir": "更新门店调研信息",
  "soda-c-i18n---联系商家": "联系商家",
  "Gattaran_transformation__pglh": "保存并返回",
  "Gattaran_management_dWbz_DrVf": "线下拜访完成度·{{month}}",
  "Internal_Tools_App_IadN_oKZj": "银行账号",
  "FoodOpB_management_Weight_sGBg": "权重",
  "FoodB_V1_pmrO_ZtzK": "已完成",
  "FoodC_edit_cKhP_xcTQ": "请在我家门口见面",
  "Internal_Tools_App2_ZTtV_pIEN": "生成路线",
  "FoodC_202410_FxEp_LCxL": "支付中",
  "FoodOpB_CO_Provisional_Tax_ZpCx": "临时缴税金额",
  "FoodC_edit_DOXu_EYnd": "例如：请敲门，不要按门铃。还可上传您所在位置附近的参照物图，方便骑手准确送达。",
  "FoodB_process_HvCv_QDks": "待整改",
  "FoodB_accompanyvisit_hlno_QKSm": "是否积极接受陪访中的反馈，并展现出明确的改进意愿？",
  "Internal_Tools_App_uXeN_VtKY": "城市",
  "FoodB_Side_cJSW_giyr": "问题订单",
  "Gattaran_V1__SttS": "营销",
  "Gattaran_V1_qsGI_Ulsk": "数据加载中，大概需要几秒",
  "Gattaran_schedule_ajzu_twuj": "数量超出提示",
  "FoodB_opencheck_tUFp_hKlC": "当前无已完成二次检查项",
  "Internal_Tools_App2_yIFi_UEbZ": "周一",
  "FoodB_0926__pZyK": "无进行中的营销活动",
  "FoodB_Show_ID_Card_BrxO": "身份证",
  "FoodB_030_zOTR_tsWu": "我的商圈",
  "FoodB_1106_tybs_uREn": "语音文件上传失败",
  "Gattaran_withdraw_Ofwd_NgCY": "撤销后本次申请流程结束，后续需要重新提交签约申请，请谨慎操作！",
  "Gattaran_merchantfee_Pqxr_WLCJ": "输入值不能大于{{max}}",
  "Internal_Tools_App_SKgO_wHcV": "财务联系人电话",
  "Gattaran_V1_YDbp_akEe": "所有有效营销活动",
  "FoodB_0617_BYzk_fNiR": "是否与竞对签约独家-R",
  "FoodB_202311_VkTS_OoIy": "已过期",
  "Internal_Tools_CRM_CJvi_BeaN": "ERP系统",
  "FoodB_survey_eOXC_QSNG": "贷款需求",
  "Gattaran_status_ojzr_GNwA": "待签约",
  "Internal_Tools_App_SvGD_UfGw": "经营数据",
  "FoodD_payout_Company_Registration_zoVW": "公司注册号",
  "FoodB_indicator_lunF_LWgo": "计算方式",
  "FoodOpB_1_Visiting_Status_rbMX": "拜访状态",
  "FoodB_audit_Distance_between_BRSw": "新旧店铺距离差异",
  "FoodD_2_Income_Vqfp": "收入",
  "Others_boarding_City_choice_ryMd": "城市选择",
  "FoodC_notice_fOyQ_lqIn": "当前现金支付不可用，请检查是否下单金额超限额或者有未完成的在途现金支付订单后，稍后重试。",
  "FoodB_Launch_DR_Foreigner_gXpW": "DO-外国人证",
  "FoodB_0617_bADA_vnGU": "自营接单服务",
  "Gattaran_0__uLBv": "请输入订单量",
  "FoodB_210811_No_tax_QkcN": "无税务文件",
  "Internal_Tools_CRM_RyhE_fFHt": "主要联系人邮箱",
  "Internal_Tools_App_ujvr_QghX": "油站图片（最多上传{{amount}}张）",
  "Gattaran_V11_fscy_YDKX": "达标标准",
  "FoodC_20240607_wfRH_rTAa": "商家信息",
  "Gattaran_form_rnAn_flyZ": "必须输入KP电话或照片任意一项",
  "FoodB_collection_Taxpayer_Postal_guUo": "纳税人邮政编码（全国）",
  "FoodB_1106_foqL_RTHY": "请通过语音录制、上传语音文件或文字输入的方式描述以下内容：",
  "FoodC_202412_nXPk_kwtQ": "未找到地址？调整关键词重新试下吧",
  "Gattaran_20240401_LMVL_IKxX": "退出APP",
  "FoodB_1106_AyGO_yZLr": "请保证网络畅通并点击重新分析按钮，我们将重新进行AI总结生成。",
  "FoodOpB_tagging_You_chose_obli": "您选择了无效商机原因为：停止营业 ，当前位置距离店铺大于{{distance}}，请检查！ ",
  "FoodB_management_Business_hours_VLnY": "平日营业时间",
  "FoodB_scenario_LpfM_MGER": "其他问题",
  "FoodC_edit_hDGv_arOT": "请在楼下大厅见面",
  "Gattaran_Visit_Personal_Goals_FDcw": "个人目标/学习",
  "Internal_Tools_App_Hrci_mwCF": "油站地址",
  "Gattaran_mgt_Search_Results_pFNV": "搜索结果",
  "FoodB_420241024_mWia_Agjc": "未达成",
  "FoodC_education__1_mJTG": "（1）如果商家已确认接单，您可通过‘取消订单‘功能与商家协商申请取消订单；如商家因已出餐等合理理由不同意取消订单，您将不能免费取消订单；如您坚持取消订单或者拒收餐品，则订单相关费用将由您全部承担；",
  "Gattaran_mgt_Indicates_that_nHWP": "表示未达标",
  "FoodB_APP_jedo_DJtn": "活动场景",
  "Gattaran_V1__hUDQ": "服务",
  "FoodB_0_Please_upload_BZIQ": "请上传聊天记录截屏",
  "FoodB_Show_Current_NJqK": "活期",
  "Gattaran_0_Clerk_nZnx": "店员",
  "FoodB_CL_power_of_KgHH": "委托书",
  "FoodC_edit_iuIV_BOva": "10分钟",
  "Gattaran_mgt_Sort_QiOq": "排序",
  "FoodB_list_KP_Phone_qQCQ": "KP电话",
  "FoodB_feedback_LxAh_DNGY": "历史",
  "Gattaran_AlertV1_CYCs_NjzG": "点击这里你可以查看需要你重点关注的商家",
  "FoodB_Contract_wsvf_fSJn": "签约协议中的堂食比价",
  "Gattaran_jumpnewstore_lspf_nNoN": "点击跳转新店成长模块，查看任务详情，助力商家完成相关任务",
  "FoodB_V2_dLkl_pbiF": "客户端版本低，请更新版本再操作",
  "FoodB_1106_QRoy_iWHx": "开始录音",
  "FoodB_opencheck_zqHl_BKuO": "是否确认将当前二次检查项设为未完成状态？",
  "FoodB_model20250116_innF_fIuu": "签退成功",
  "FoodB_management_Store_association_coYB": "关联门店",
  "FoodC_202408_ksyj_sXlp": "关于店铺",
  "Internal_Tools_App2_tYvt_cIHY": "今天",
  "Gattaran_store_ylep_UGpm": "请前往正式入口完成签约",
  "FoodC_202412_dCuL_VUFU": "重新定位",
  "Gattaran_0_Are_there_ouHJ": "是否有其他店铺",
  "FoodC_202412_bolI_YXBT": "已保存地址",
  "FoodB_B86_Bhsy_ekdS": "违规管理",
  "FoodD_Storefront_YFcS_cnUy": "Storefront",
  "Internal_Tools_App_WpuB_Tmys": "是",
  "FoodC_202412_Oant_EESB": "下一步",
  "Gattaran_0_Edit_contacts_nCLZ": "编辑联系人",
  "Gattaran_20250610_qChL_aFTc": "请联系商家完成合同确认并且完成RTBO",
  "Gattaran_function__fALF": "取消",
  "FoodB_method_hwZM_aUnb": "下载Explorer",
  "Gattaran_Feedback__urHD": "低",
  "Internal_Tools_App2_NTbv_hmkk": "无拜访信息",
  "FoodB_management_Automatic_closing_xRSd": "自动关店",
  "Gattaran_opt2_UTsL_QVlH": "其他",
  "Gattaran_Visit_Total_score_iZIW": "总得分",
  "Gattaran_202406_xlNL_HNSV": "文件类型信息建议通过GTR-销售任务管理页面上传",
  "FoodC_202408_RRtT_ZjIG": "请添加收餐地址",
  "FoodC_20240607_hhNB_mCBD": "手机号",
  "FoodB_2_AOP_VVZV": "AOP",
  "FoodB_email_QTTk_ZllR": "发送协议给品牌",
  "FoodB_V1_raHO_jXSF": "本月R burn/GMV",
  "FoodB_20231012_GZve_uPZM": "该任务类型已经设置任务截止时间计算规则，不需要您再次填写",
  "FoodB_diagnosis_Items_qQOR": "菜品",
  "FoodB_accompanyvisit_WLlY_tKoQ": "陪访规划、系统和目标聚焦",
  "FoodB_field_No_need_hToz": "不需要",
  "FoodB_2__YqWB": "拒绝原因",
  "FoodB_APP_rwZD_SFlh": "B2C + P2C burn / GMV",
  "FoodC_edit_Fyzp_tERt": "请保持手机畅通，骑手到达后将会联系您，并在约定位置等待您{{time}}",
  "Internal_Tools_CRM_nTMX_ElyI": "油站精确位置",
  "FoodOpB_Translation_Passport_jpaq": "护照",
  "Gattaran_Visit_Pre_visit_NLpf": "准备工作评分",
  "FoodB_opencheck_qJag_QHzZ": "门店接单及配送设置",
  "FoodB_requirement_uBiP_YocR": "出餐超时率",
  "Internal_Tools_App_RxZj_EZmI": "本周",
  "Gattaran_Visit_Tracking_KfAS": "追踪",
  "FoodB_calculator_CcKA_weRh": "仅供参考。支付给商店的最终付款将可能因取消、售后问题等问题而被扣除。",
  "FoodC_202408_qGSr_IQoW": "修改",
  "FoodB_APP_mDID_tHft": "选择数据时间段",
  "FoodB_incomplete_hmSA_mNRv": "标记为未完成",
  "Internal_Tools_App_QNzF_fvmK": "合同状态",
  "Gattaran_add_MyGp_GdUb": "avatar",
  "FoodOpB_1_Visit_today_hLhX": "今日拜访",
  "soda-c-i18n---提交申请": "申请取消",
  "FoodB_sob_FZWe_QYdT": "已绑定{{num}},引导商家使用该手机号登录SOB官网完成签约",
  "Gattaran_function__PRSL": "下载",
  "Internal_Tools_App2_drNi_CAgA": "周四",
  "FoodB_page_ErfH_yeAb": "请上传相关拜访的证明，例如：聊天截图，线上会议截图，邮件截图",
  "Gattaran_0_Consistent_with_CiFN": "与线下价格一致",
  "FoodOpB_v2_Type_BpqS": "类型",
  "FoodB_1106_zLsQ_PVUN": "跟进方式",
  "FoodB_1106_UWHB_lYiW": "录音转录",
  "FoodB_1106_oEsa_BYuK": "下一步计划是什么？",
  "FoodC_202408_cjXm_VVcd": "退出后将无法查看订单",
  "Gattaran_0_Buy_gifts_dbKh": "买赠",
  "Gattaran_statusbar2_QzkZ_tHWY": "草稿中",
  "FoodB_clockin_NbrI_oMtd": "打卡时间",
  "FoodB_opencheck_UtkB_sIJi": "是否完成二次检查",
  "Gattaran_0_No_match_Tgve": "免配",
  "Internal_Tools_App_UIXX_nKyD": "最多可查看360天内的数据",
  "Gattaran_visit_nNId_fOhX": "BD进行了有效的拜访",
  "Gattaran_REGULAR_irYR_Bntt": "若您不清楚是否RFC有效，请复制您的税号并通过以下官网链接进行查询",
  "Gattaran_opt_ikuS_aRyl": "拜访结果",
  "FoodB_Contract_tvcI_RNvn": "成功上传审核通过的堂食菜单",
  "FoodC_revision_Less_meal_pHwq": "餐品问题反馈",
  "FoodB_page_gpRd_UWVk": "抱歉，摘要生成失败",
  "FoodB_task_HEvc_Emme": "{{X}}个任务在本次拜访中已执行",
  "Gattaran_Visit_Rating_after_lruO": "拜访后评分",
  "FoodB_1106_uIrJ_FVVL": "核心进展/客户需求/关键问题是什么？",
  "FoodB_communications_UOIk_QdZg": "完成新店成长任务获得额外权益，任务在{{task_left_days}}天内到期",
  "FoodOpB_Translation_Please_add_mxTD": "请添加上传以下三种文件中的任意一种即可：法定代表人授权书、商业登记、更新状态证书",
  "FoodB_process_hZyR_OxLH": "复制{{name}}店铺链接",
  "FoodB_page_NuZX_bcTU": "拜访过程或需要被记录的重要进展",
  "FoodB_Fields_CnCd_RzYS": "审核中",
  "FoodC_method_Wait_keAM": "再等等",
  "FoodOpB_management_Corresponding_fractions_QlGf": "对应分数",
  "FoodB_CL_Simple_company_JBRG": "简单公司",
  "FoodC_edit_bxpb_udFq": "例如：中心大道88号，中心大楼",
  "FoodB_IV_Open_shop_xlhI": "自动开店",
  "Gattaran_visit_xnVQ_bENu": "待改进之处",
  "Gattaran_0_Package_fweo": "套餐",
  "Internal_Tools_App_SruZ_Bhfa": "精确位置",
  "FoodB_1106_eUGB_DZjs": "核心进展",
  "Internal_Tools_Ops_ouPX_WYmu": "油站编号",
  "FoodB_1106_oWun_aWqC": "暂无核心进展",
  "Internal_Tools_App2_laAj_weWi": "继续",
  "Gattaran_Visit_After_a_ILbF": "拜访后",
  "Gattaran_20240902_ahLx_jQSe": "你为{{shopname}}发起的{{tasktype}}任务被驳回，请结合驳回原因完善任务参考信息",
  "FoodB_page_YAuh_BBZp": "分析结果",
  "FoodB_0622_Store_management_ztNB": "门店经营",
  "FoodB_20250612_WpCB_xKZJ": "其他",
  "FoodB_202402_TFYh_dasm": "其他",
  "FoodB_2_phDI_Aept": "上传证明图片",
  "Gattaran_202406_SQiw_AXZW": "销售任务管理",
  "Gattaran_tag_mnOh_LlIQ": "活动即将到期",
  "Gattaran_V1__zewR": "菜单",
  "Gattaran_store_HrLF_aQuF": "去入驻",
  "Gattaran_Collection__twwL": "可以在这里查看全部拜访记录",
  "FoodB_1106_grLB_GkRM": "如果您在文件上传的过程中离开页面，则当前结果不会被保存。",
  "FoodC_202408_tlOV_uOmJ": "绑定手机号即可开启优惠订餐",
  "FoodB_communications_hhCR_kEAh": "门店本周有任务到期",
  "FoodB_FAQ_RQfm_qTIo": "相比昨天：",
  "Gattaran_page_DWAi_yiXk": "店铺签约",
  "Internal_Tools_App_pynL_unFB": "商户类型",
  "Gattaran_V11_DQdi_QRqK": "未达标",
  "Gattaran_mgt_Performance_data_ymwM": "绩效数据",
  "FoodB_field_Needs_IbzB": "需要",
  "Internal_Tools_CRM_APZA_BShD": "基础信息",
  "Internal_Tools_App_NkMV_mnZQ": "通过地图定位",
  "FoodB_management_pBMo_Pdsx": "已复制到粘贴板",
  "FoodB_Side_Etep_PIxp": "出餐超时",
  "FoodB_1106_ACTr_mhVt": "确定",
  "Gattaran_0_Visit_Information_hzgb": "拜访信息",
  "Gattaran_opt_KdGX_oUmM": "签约",
  "FoodB_survey_yEPf_ujZP": "竞对日完单量-P",
  "FoodB_executors20241225_bYiY_UfOD": "自动分配逻辑",
  "Gattaran_center__TkvV": "暂无消息",
  "soda-b-homepage-i18n---首位必须是1，必须输入11位": "首位必须是1，必须输入11位",
  "Gattaran_Visit_APP_Review_nbGn": "APP审查",
  "FoodOpB_Org_Add_at_nQez": "至少添加一个指标项，请重新设置",
  "FoodB_comparison_dRXO_qebt": "整改价格",
  "Gattaran_form_nFaJ_bcHw": "联系人",
  "FoodB_1106_jqDc_LmDv": "您的录音上传失败，请确保网络畅通并重新进行语音录入。",
  "Groceries_1_MhVY_Etfm": "换货新商品",
  "Internal_Tools_App_AFZd_haQA": "集团",
  "FoodB_collection_Enter_idCIF_NeUD": "请输入idCIF",
  "Internal_Tools_App_XqPY_lOag": "支付方式",
  "FoodB_accompanyvisit_tcgk_TvAZ": "BD是否熟练使用CRM系统来组织拜访并规划后续事宜？",
  "FoodB_process_jvuI_tPXa": "选择主菜",
  "Gattaran_side__sOcs": "星期二",
  "Gattaran_REGULAR_OPsx_JMnf": "计算",
  "FoodB_opencheck_EdLx_RFyR": "请检查{{99store}}上线与接单配置",
  "FoodB_scenario_YcnE_hnLK": "订单地址位于危险区域",
  "FoodB_up20241218_VRuL_OZqJ": "招商预报名",
  "FoodB_audit_The_strings_NPFx": "点击确定后会发起{{strings}}审核流程，且在审核完成前不可申请签约，是否确定？",
  "Gattaran_cancelation_divJ_nbOW": "任务未执行",
  "Gattaran_Mode_DJzU_JeyE": "业态",
  "FoodB_feedback_PCwL_NbGi": "反馈提交失败",
  "FoodC_1_dXUH_ThDd": "查看更多",
  "Gattaran_Visit_View_Visit_eZdF": "查看拜访计划",
  "Gattaran_Process20250815_EISY_wPEZ": "佣金申请审核中",
  "FoodB_ads_yERH_XMYy": "招商广告活动是否报名成功",
  "GDriver_B_apbe_dntZ": "油站名称",
  "Internal_Tools_App_lbMG_ilBX": "服务设施",
  "Gattaran_v1_guwq_yflY": "点击展示招商活动详情",
  "FoodB_governance_ireV_yxHO": "任务截止时间",
  "FoodC_edit_oOAR_FExH": "写字楼",
  "FoodC_202412_MrwA_fRUi": "店铺休息中，稍后再来吧",
  "FoodB_0707_Lifted_off_tnXl": "已下架",
  "Gattaran_ProgressManagement_ArNE_PsZi": "处理人",
  "FoodB_email_qdfP_heFs": "您好，我们拜访了您的门店{{store_name}}，并与{{person_to_be_visited}}一起查看了以下内容：",
  "FoodB_management_osog_jVEE": "店主的朋友/家人",
  "FoodB_0113_ZcCF_NbjE": "你可在此添加拜访计划",
  "Gattaran_0__VQyB": "我的门店",
  "FoodB_Show_Special_residence_ezfV": "外国人特殊居留证",
  "FoodC_202408_ajMC_lsta": "店铺已打烊",
  "FoodB_audit_Review_Opportunity_ZQHk": "商机基础信息编辑审核",
  "FoodB_Contract_ZLgE_qHzf": "签约协议中的竞对比价",
  "FoodC_202408_RTrU_hOhN": "请先开启位置访问授权。系统设置->找到应用程序->开启位置访问授权",
  "FoodB_audit_Click_OK_Zfsf": "点击确定后会发起",
  "Gattaran_V2_xKud_MVWh": "不可以代报名活动",
  "FoodB_time_All_day_TIsU": "全天歇业",
  "FoodC_page__iyoe": "收起",
  "FoodB_accompanyvisit_DoUc_ZSSY": "BD是否能与决策者明确后续步骤，并正确记录待办事项及工作计划以便下次跟进？",
  "FoodB_1106_PVUq_gUVg": "语音录入",
  "soda-c-i18n---将赔付给您1张%s折扣券": "将赔付给你1张%s折扣券",
  "FoodB_0622_Sales_KRCg": "销量",
  "FoodB_page_gnPj_beOZ": "请清晰说出以下内容:",
  "FoodB_0617_lXTk_DfVL": "竞对独家合同到期日期-R",
  "Internal_Tools_CRM_MKcO_yldx": "线索来源",
  "FoodB_20250612_nsLy_sirO": "必须输入8-9位数字",
  "Gattaran_opt_JcLo_plhe": "在线时长",
  "FoodOpB_1_Fill_in_QvuH": "填写拜访计划",
  "Internal_Tools_CRM_fHSX_VjzW": "精确位置错误，请重新选择",
  "FoodB_subsidy_xslH_mDaQ": "该佣金补贴补充协议会以该门店的所属主体名义进行签约，目前该主体下存在多家已签约的门店，因此这些商家会同时新增佣金补贴，是否确认继续签约？",
  "Gattaran_0_Increase_in_yvaq": "增加营业时长",
  "Gattaran_202406_wmja_Unkw": "任务执行人",
  "FoodB_page_zXlL_VKXp": "创建新录音",
  "Internal_Tools_App_sOCx_HZNJ": "今日营业时间",
  "FoodC_202412_PwIG_QPFY": "输入地址",
  "Gattaran_84_Khbi_virb": "平台检测时间",
  "Gattaran_opt_jfHC_vGTC": "本月完单",
  "Internal_Tools_CRM_eqgV_MrAE": "请输入正确的的经纬度",
  "FoodC_202408_PJcq_SjqG": "抱歉，店铺没有留联系方式",
  "Internal_Tools_App2_oKVZ_QNJf": "拜访计划已创建成功",
  "FoodB_0322_gUpY_CIHG": "当前筛选条件下无匹配店铺",
  "FoodB_list_Apply_for_RxQn": "申请签约",
  "FoodB_field_Is_you_uNye": "是否需平台申报全国的税",
  "soda-c-i18n---延迟送达%s分钟以上": "延迟送达%s分钟以上",
  "Gattaran_invalid_Itxj_ruEf": "已剔除无效商机，如需查找无效商机请自行筛选或使用搜索功能",
  "Internal_Tools_App_ROpA_rFNd": "财务联系人邮箱",
  "Gattaran_0_Using_Store_khfo": "使用商家端设备",
  "FoodB_calculator_hPAw_BZlP": "瓜纳华托州Cedular税金额",
  "Gattaran_202406_rpdn_vXVr": "备注",
  "FoodB_clockin_guJt_eDVT": "已过期",
  "FoodB_accompanyvisit_YOaS_TWOq": "BD是否在每天工作前明确了解陪访目标（每周的目标和重点），并且访问是否经过战略性规划（区域、餐厅概况等）？",
  "FoodB_process_tlsV_pFnp": "确认匹配",
  "FoodC_homepage_Search_for_CiMZ": "搜索美食",
  "FoodB_model20250116_wlQy_yyEp": "拜访时间",
  "Internal_Tools_CRM_hQxQ_PeNI": "油站类型",
  "Gattaran_0_Full_gift_nhuV": "满赠",
  "FoodB_b_Source_of_qGPd": "活动来源",
  "FoodB_0_Please_upload_roTo": "请上传邮件记录截屏",
  "Gattaran_status_Gnih_zZzX": "已完成开店检查项",
  "FoodB_opencheck_BcIJ_lgZH": "测试订单",
  "FoodB_governance_Kygz_iFAW": "是否完成堂食比价整改",
  "FoodB_email_NJBQ_LwUX": "该联系人暂无邮箱，无法发送邮件，请补充邮箱后再选择",
  "Gattaran_0_App_Operator_HJuu": "App操作员电话",
  "FoodB_202202_Minutes_tWiN": "分钟",
  "Gattaran_V2_XvaI_scMD": "数据更新时间：{{update_time}}",
  "FoodB_calculator_WFgZ_JmvX": "付款计算器",
  "FoodC_education_Principles_of_RKEk": "取餐纠纷处理原则",
  "Gattaran_mgt_Search_History_DIkw": "搜索历史",
  "Gattaran_center__IJmL": "消息",
  "Gattaran_schedule_eLPM_Vdmp": "继续",
  "Gattaran_visit_Zykg_WdpB": "BD为拜访做了准备",
  "FoodB_up20241218_WbCj_pCMp": "新店特价菜预报名",
  "Internal_Tools_App_xIAG_xcRt": "单次最长查询范围是30天",
  "Gattaran_form_HAwV_aOvm": "拜访结果",
  "FoodB_opencheck_BEkt_nVNw": "请确认商家出餐时长配置是否合理，会影响配送时间",
  "FoodB_0617_tikP_Dusl": "门店调研",
  "FoodB_process_PFDy_CuVh": "审核中",
  "FoodB_20250612_ehqr_pgKz": "门店经理",
  "FoodOpB_Translation_General_accounts_NeVu": "一般账户",
  "FoodB_accompanyvisit_lehr_PbIH": "陪访规划是否考虑了卖家画像、区域特征及推进机会等战略标准？",
  "FoodB_in_pQps_Boqn": "重新拍摄",
  "FoodC_MVP_ASpO_MFfF": "订单详情",
  "Internal_Tools_App_wStM_yTkP": "油站位置：{{Address}}",
  "FoodB_Translation_mIfp_fymE": "去处理",
  "Gattaran_side__EgXn": "星期一",
  "FoodC_details_Refund_Details_sGIk": "退款详情",
  "Internal_Tools_App2_evQx_VnhU": "油站名称/税号",
  "FoodB_250430_GwJd_SQQB": "店铺级别",
  "FoodB_Translation_IfKE_iqmc": "整改失败",
  "FoodOpB_CRM_Taxpayer_Address_ptqR": "纳税人地址（当地）",
  "Gattaran_Visit_Management_and_JkoC": "管理和后续步骤",
  "Gattaran_Visit_Select_a_YAtw": "请选择陪访日期",
  "Gattaran_center__vsus": "点击了解详细内容",
  "FoodB_APP_wyiJ_mGlw": "开始月份",
  "FoodB_20250414_faym_bhsa": "平台补贴",
  "Gattaran_management_cYvq_XraB": "无拜访信息",
  "Gattaran_transformation__njrW": "签约主体名称",
  "Gattaran_Visit_New_escort_zHov": "新建陪访",
  "FoodB_calculator_tLev_cAgO": "电子支付",
  "Gattaran_uikey_qCBF_mlck": "Commercial Offering",
  "FoodB_new1_Name_similarity_gepH": "名称相似度",
  "Gattaran_V1_JVoT_DmFC": "查看",
  "Gattaran_opt_qiBN_MCGQ": "撤销",
  "FoodB_page_tFIa_cbzN": "请录入或上传一段语音，录入后系统将为您自动生成拜访摘要。限制：录音最大录入时长为120秒，上传音频文件不得超过50M",
  "Gattaran_202311_xiHr_yFIi": "推荐",
  "Gattaran_optimization_Tore_pnsp": "系统发现你的定位已发生变化，是否刷新当前页面？",
  "Gattaran_form_hGfR_KtSN": "添加拜访结果",
  "Gattaran_management_gqoK_XBEn": "今天",
  "Gattaran_page_tcVj_BzPA": "请协助商家登录管理端完成签约和RTBO",
  "FoodC_202408_sbmp_YFyl": "当前位置",
  "Gattaran_202406_TbgT_vOga": "是否确认提交？一旦提交不可修改",
  "FoodB_accompanyvisit_TVci_lcvJ": "是否妥善处理了后续事宜：文件采集、签署、下载、测试订单和餐厅的上线流程？",
  "FoodB_Side_ZUeL_zYXD": "取消订单",
  "FoodB_Optimization_xyJu_XgOc": "请输入10位数字",
  "Gattaran_20240902_KYYY_BwXS": "请详细描述任务驳回原因",
  "FoodB_opencheck_XJFL_avly": "确认",
  "Gattaran_V1_IUgS_cyMV": "商家可报名",
  "FoodD_problem_I_see_NhGG": "我知道了",
  "FoodB_optimization_Contract_No_GvBj": "合同编号",
  "FoodB_list_Online_Inspection_rExT": "上线检查项",
  "FoodB_20250122_WEun_Whes": "分发任务前置条件",
  "Gattaran_202406_lKot_vsVa": "在GTR系统销售任务管理模块下载文件",
  "FoodB_v12_iuCB_kwbr": "是否有物流集成商",
  "Gattaran_function__DqfF": "版本更新",
  "FoodB_switch_yJQj_DSir": "是否授权平台100%补贴活动",
  "Groceries_brand_bqwY_mhhq": "创建成功",
  "FoodC_sales_Supplementary_information_ihyk": "补充信息",
  "FoodB_accompanyvisit_wPYQ_hebq": "商业流程与结果导向",
  "FoodB_2_Planned_bPON": "计划中",
  "Internal_Tools_App_dIhB_OKLN": "设置为主要联系人吗？",
  "FoodB_accompanyvisit_QWRh_eKLI": "BD是否有自动记录访问并收集RTBO数据的习惯以便立即录入系统？",
  "FoodB_1106_jWEH_dYMs": "重新分析",
  "FoodB_opencheck_ybHy_nAdV": "门店电话",
  "FoodB_Wordings_iyFv_fDmW": "补充说明",
  "FoodC_education_In_the_nIgD": "下列取消订单的情形下，您需承担责任：",
  "Gattaran_schedule_yPeR_CtMc": "当日线下拜访计划超过{{number}}条，将默认为你选择前{{number}}个拜访计划生成路线",
  "FoodC_202412_SJdc_Bwta": "非附近地址？请点击右侧按钮重新获取位置。",
  "FoodC_dish_New_guest_bkGC": "新客专享",
  "FoodC_202408_WiRK_SITI": "添加地址",
  "FoodB_in_kJaI_fOxY": "有未签退的打卡记录，请签退后关联打卡时间",
  "FoodB_GTR_rBBn_RmKL": "普通",
  "FoodOpB_Home_Mandate_vafk": "任务",
  "FoodC_education__2_KHhl": "（2）如您超过平台规定的时间未到达交餐点、订单地址填写错误、收餐号码错误、拒接送餐人员电话、无正当理由拒收餐品，您需要支付订单费用",
  "FoodB_management_Queries_dawh": "查询",
  "Gattaran_V2_Vqiq_pMHI": "任务说明",
  "Gattaran_V2_Sjdp_HgTP": "活动ID",
  "FoodB_calculator_giVW_AULQ": "平台单价",
  "FoodC_education_If_you_RTIV": "您成功支付外卖价款后，如需要取消订单的，将按照如下规则进行：",
  "FoodB_1106_xaYu_lPMa": "快速跟进",
  "FoodB_calculator_EeIc_TwiG": "公司",
  "FoodB_optimization_Stimulate_contact_xSSH": "倾向联系方式",
  "Gattaran_20240918supplement_ISmP_qTmN": "编辑任务",
  "FoodB_B86_Kypx_nBHu": "备注",
  "FoodB_0919__mVqa": "出餐超时数",
  "FoodB_opencheck_aDuZ_bepq": "商家移动端下载",
  "FoodC_receive__UdqW": "天",
  "FoodB_420241024_FldG_feZL": "目标值",
  "Internal_Tools_CRM_pWry_BgtM": "请选择",
  "Gattaran_202406_NcUB_dVhS": "任务创建时间",
  "FoodOpB_center_Action_MexV": "操作",
  "Internal_Tools_App_fTOH_ETfJ": "请输入",
  "FoodB_Contract_tFOZ_SiQZ": "是否成功报名营销活动",
  "Gattaran_opt2_egxV_xfoW": "问题订单率",
  "Gattaran_mgt_Display_content_IlcO": "展示内容",
  "Gattaran_0__BHKX": "地图",
  "Gattaran_tools_IbIT_QTXz": "请输入合法的电话号码",
  "Gattaran_management_IDJi_lZyx": "{{amount}}今日拜访计划，查看你的规划",
  "Internal_Tools_CRM_bNjK_DISV": "偏好拜访方式",
  "FoodB_Show_Company_Registration_VcVV": "公司注册号（CJ）",
  "FoodB_Contract_BRLH_nPAs": "是否完成首次上线",
  "FoodB_0617_Cgpc_KwbS": "请输入两位小数",
  "FoodB_scenario_FmAJ_xFEY": "疑似诈骗或恶作剧",
  "FoodB_Contract_ywoA_Ojgz": "否",
  "FoodB_model2025011603_ztWt_rarX": "请先选择拜访方式和拜访类型",
  "FoodC_202408_cktm_HTVV": "知道了",
  "FoodOpB_OpsTasks_Off_GCPV": "关闭",
  "Gattaran_mgt_Gap_BnAE": "差距",
  "Gattaran_20230803_WsGI_IIwM": "目标",
  "FoodB_SimbaSignup0331_qKdR_ELgg": "商机来源",
  "Gattaran_20240401_LxEe_Ydha": "问卷调研",
  "Gattaran_0__tYzF": "当前区域没有门店，拖动地图加载更多",
  "Gattaran_84_xcpB_yRxH": "主体ID",
  "FoodB_scenario_tTcW_glIK": "菜品售罄",
  "FoodB_20250414_BqXP_FPkP": "老客占比",
  "Gattaran_Visit_Objection_management_WIuV": "异议管理",
  "Gattaran_cancelation_TYFD_JQzM": "{{N}}个任务未执行",
  "优惠券": "优惠券",
  "FoodB_250430_YTkG_lNTj": "品牌级别",
  "FoodC_optimization_hksX_yevn": "请添加您的见面地址，否则将无法为您正常配送",
  "FoodOpC_jiatalan_Deleted_successfully_GeGq": "删除成功",
  "FoodB_1106_XZeN_ahHQ": "在您完成内容录入后，系统将自动为您生成AI总结。",
  "FoodB_calculator_cctL_sltb": "菜品总价",
  "soda-c-i18n---订单实际送达时间晚于预计送达时间%s分钟以上、%s分钟以下，": "订单实际送达时间晚于预计送达时间%s分钟以上、%s分钟以下，",
  "FoodB_collection_5_6_hFrc": "5-6位数字",
  "Gattaran_opt_lDge_zZTn": "点击跳转地图导航；点击电话标志查看KP及商家联系方式",
  "Gattaran_management_icdH_hGfu": "详情",
  "Gattaran_0_Training_DM_ozrH": "培训DM或App操作员",
  "FoodB_email_WcaT_rLqN": "拜访结果未填写完成，请填写拜访结果后再优化该模块",
  "FoodB_accompanyvisit_ugDE_XHAA": "描述BD在接洽中是如何自我定位的：是否展现了自信、同理心以及与客户建立了真诚的联系？",
  "Others_platform_Tax_documents_jEir": "税务证件",
  "Internal_Tools_App_sfLV_YhZV": "离开",
  "FoodB_communications_udno_SENU": "营销活动待接受，加入营销活动促进订单增长",
  "Gattaran_0_Maximum_number_pgYM": "每种角色最多新建一个人",
  "FoodB_opencheck_IVoR_xnHT": "二次检查项",
  "FoodB_CL_Letter_of_EmKs": "委托书-执照照片",
  "FoodB_0113_ELbg_zfBg": "你可在此查看门店KP信息",
  "FoodB_Analysis_Old_people_fwCy": "老客",
  "Gattaran_0__iUtr": "邮箱",
  "FoodOpB_Translation_Natural_persons_fVFa": "自然人",
  "FoodB_0905__wwdP": "分项权重",
  "FoodC_edit_ldOR_SyHv": "例如：我穿着花衬衫，在街边等候。还可上传您所在位置附近的参照物图，方便骑手准确送达。",
  "FoodC_improve__ByLg": "与预期不符",
  "FoodOpB_Tool_Set_FrCO": "未设置",
  "Gattaran_v1_fltf_eBMP": "已报名，请在商家平台查看详细信息",
  "Gattaran_0_Purpose_of_COzp": "拜访目的",
  "soda-c-i18n---超时赔付规则说明": "超时赔付规则说明",
  "FoodB_page_SFRj_eGOy": "拜访结果",
  "FoodC_education__1_IIfh": "（1）在商家接单前，您可以在订单详情页通过‘取消订单’功能进行取消",
  "FoodB_0905__vMsv": "与上一统计周期相比，增加{{number}}单",
  "FoodB_accompanyvisit_yIeT_NmXn": "是否展现出自信果断的促销谈判能力，并充分强调促销方案为餐厅带来的收益与曝光价值？",
  "FoodB_Contract_cBzR_gTDZ": "签约协议是否有竞对比价",
  "FoodD_messagemanagement_Mail_UMqH": "邮件",
  "Gattaran_selection_TfHc_eCVN": "未完成的上线检查项",
  "FoodOpB_Tool_Completed_MjfD": "已完成",
  "FoodB_comparison_utxs_QFHY": "确认匹配",
  "FoodOpB_1_Visit_tomorrow_ptjT": "明日拜访",
  "FoodOpB_system_DiDi_ALAy": "DiDi合作",
  "Gattaran_202406_hoAo_HpXw": "收到的（{{N}}）",
  "Gattaran_0_KP_tendency_YwDf": "KP倾向联系方式",
  "FoodB_collection_Taxpayer_ID_zntM": "纳税人身份证（CURP）",
  "FoodB_V2_No_store_ahBo": "无门店税号",
  "FoodB_0617_pPbU_koUF": "是否与竞对签约独家-U",
  "FoodC_202412_QwDD_sIOi": "超出配送范围",
  "FoodB_subsidy_czaK_LuDh": "BD APP不支持此类型的商户签约，请移至GTR进行签约。",
  "FoodB_tagging_You_have_ssrJ": "您选择了无效商机原因为：非零售店铺，必需填写照片或KP电话任意一项！",
  "Gattaran_schedule_qPDb_CTYm": "生成路线",
  "Gattaran_202311_JOTQ_efhW": "无推荐拜访",
  "Gattaran_0_App_Operator_PFUQ": "App操作员姓名",
  "FoodB_20250414_pQls_dkIZ": "老客人数",
  "FoodC_202410_UazG_LTwS": "暂无可点餐店铺",
  "FoodB_process_mpIE_dSWO": "整改失败",
  "FoodB_governance_coYD_UvmL": "是否完成跨平台在线整改",
  "FoodC_202410_hAya_NcZF": "确认({{countdown}}秒)",
  "FoodB_Show_Special_Tax_Eidl": "特殊纳税号码",
  "FoodB_Contract_rrZL_POpC": "{{brand_name}}价格{{unit}}{{number}}%堂食价格",
  "FoodB_accompanyvisit_zjgE_DCvu": "职业素养、应变能力与投入度",
  "Internal_Tools_App_SHoN_atyR": "油站",
  "Internal_Tools_App2_gcDq_GLYj": "成本价详情",
  "Gattaran_0_Self_marketing_BQlO": "自营销",
  "FoodC_education__2_KZTZ": "（2）骑手联系不上顾客",
  "Gattaran_Optimization_VLZp_WhPs": "查看商家地址",
  "FoodB_leads_KP_Phone_hCUe": "KP电话 2",
  "FoodOpB_APP_Visit_vdze": "拜访",
  "FoodB_Contract_PpIv_FHlg": "签约协议是否有佣金补贴",
  "FoodB_Wordings_DKwT_wbfI": "请说明您的选择理由，您的反馈对我们非常重要，有助于我们改进！",
  "FoodB_new1_Similarity_ItET": "相似度",
  "FoodB_V2_iZpC_KKcK": "分享诊断报告给商家",
  "FoodD_h5_Single_quantity_lrNq": "完单量",
  "FoodOpB_1_New_Visiting_tIni": "新建拜访计划",
  "Internal_Tools_App_HdHN_rUqy": "油站服务",
  "Gattaran_statusbar2_HKvC_dhsJ": "已签约",
  "Internal_Tools_App_yiaL_Hsph": "推荐上传油站照片",
  "FoodC_20240607_qihL_obWb": "店铺不存在",
  "Gattaran_form_Iqrg_LVTe": "请输入数字",
  "FoodC_202409_rOOL_Peyp": "输入手机号",
  "Internal_Tools_App_zYXv_Uwsb": "经营状态",
  "FoodB_in_PTBa_SlOx": "填写拜访表单",
  "FoodB_1106_rrpW_kMlP": "AI总结",
  "FoodD_Name_July_RJXL": "七月",
  "FoodB_email_Bwgs_muyN": "店员",
  "FoodOpB_bill_Status_doqj": "状态",
  "FoodOpB_1_Closed_ieMb": "已关闭",
  "Internal_Tools_CRM_uCms_fFPv": "主要联系人电话",
  "FoodC_check_HTib_sWqA": "准备下单",
  "FoodB_20250414_cwcj_LKFT": "P2",
  "Gattaran_V1__xaNO": "取消率",
  "FoodC_intostore_Store_Coupon_kHwh": "商家券",
  "Gattaran_mgt_Filter_WuXS": "筛选",
  "Gattaran_REGULAR_xhms_NLbn": "重置",
  "Internal_Tools_App2_TpmY_bfhb": "拜访",
  "FoodB_survey_wjGW_FMpe": "{{brand_name}}资金支持",
  "Internal_Tools_App2_wcQW_nFJu": "当前选择的日期与已存在的拜访计划重复，提交后会覆盖之前的拜访计划。",
  "Gattaran_promo_zwtN_ucNY": "商家不支持设置智能营销",
  "FoodC_homepage_Enter_delivery_IZAu": "输入配送地址",
  "Gattaran_opt_nyES_OcBw": "订单",
  "FoodC_Card2_When_the_sFOa": "开店时间",
  "Gattaran_opt_slKF_FRuu": "超时未接单",
  "FoodB_0905__dSOH": "店铺诊断",
  "Gattaran_opt_xozr_fXeD": "本月R Burn",
  "FoodB_collection_12_or_woYo": "12或者13位数字符，必须大写，不能有空格",
  "FoodB_Launch_DR_Military_Rxvi": "DO-军人证",
  "FoodB_Contract_UTbX_JhBf": "签约协议是否有堂食比价",
  "GRider_dlp_Mjnq_pnxH": "其他信息",
  "Internal_Tools_App_BBZi_lqDC": "保存",
  "FoodOpB_CO_Store_official_VsRU": "商户官网",
  "FoodC_202408_HkLu_Mwgv": "位置权限未授权",
  "FoodC_202408_QAer_OYaB": "嗨，欢迎光临！",
  "Gattaran_V2_JYDK_jtcb": "活动报名时间",
  "soda-c-i18n---1、超时赔付服务是%s为您免费提供的服务，当前订单（不含已取消订单）未在预计送达时间内送达，%s将赔付给您一定金额的优惠券，订单完成后可以在中查看。": "1. 超时赔付服务是%s为你免费提供的服务，当前订单（不含已取消订单）未在预计送达时间内送达，%s将赔付给你一定金额的优惠券，订单完成后可以在中查看。",
  "FoodC_edit_SkdG_WQKu": "请在酒店大堂见面",
  "FoodB_Contract_Jthe_YSbD": "是否更新门店调研信息",
  "Gattaran_display_gAVa_nBnn": "一址多店",
  "FoodC_education_1_Customers_Gpbb": "1. 顾客可在下单前选择交餐方式，平台会要求骑手按照顾客所选择的方式进行处理：",
  "Gattaran_Collection__oNFU": "使用Google Maps导航",
  "Gattaran_20240401_iGPg_djYX": "去填写",
  "Gattaran_0__eeft": "全部门店",
  "FoodB_1106_uAeK_oOBq": "请描述您做了什么工作？核心进展/客户需求/关键问题是什么？下一步计划是什么？",
  "FoodD_Name_April_UHuR": "四月",
  "FoodC_20240607_STdK_ZTMu": "本平台技术服务由{{brand_name}}提供",
  "FoodB_opencheck_sdms_sZcq": "当前已完成全部二次检查项",
  "soda-c-i18n---将赔付给您1张%s优惠券": "将赔付给你1张%s优惠券",
  "FoodB_page_hqXm_mrng": "摘要",
  "FoodC_20240607_Olbe_DAqS": "加载失败",
  "FoodB_20250414_oAyQ_liSz": "最终折扣",
  "FoodOpB_system_offline_ersI": "线下",
  "Internal_Tools_App_xBYh_JJGr": "距离",
  "Gattaran_Grocery__pKzk": "商超模式",
  "FoodB_scenario_psNp_kSMI": "门店无骑手",
  "FoodC_sidebar_Scan_QR_ONzJ": "扫描二维码",
  "FoodB_in_qxwR_OBuC": "商家定位不准确，请上报正确信息。",
  "FoodB_sob_ixDC_aXor": "请输入商家手机号",
  "FoodB_page_oZob_DASd": "请保证网络畅通并重新录入语音",
  "FoodOpB_systemV2_Corresponding_coefficient_nVdO": "对应系数",
  "FoodD_Name_January_lhYr": "一月",
  "FoodB_1106_wohA_bqJX": "AI正在进行分析总结，请稍后回来查看。",
  "FoodB_1106_tdLw_uSLP": "全部",
  "FoodB_score_lThf_wlQT": "健康分",
  "Gattaran_opt_oUrr_YTIV": "签约状态条",
  "FoodOpB_tool_Category_main_aHZl": "主营品类",
  "FoodB_email_CuqE_WLmP": "您好，我们拜访了您的品牌{{brand_name}}，并与{{person_to_be_visited}}一起查看了以下内容：",
  "Internal_Tools_App_YNFM_WUWd": "筛选",
  "FoodB_20250122_yAtY_FAOX": "任务执行方",
  "Internal_Tools_App_EMFl_vDCu": "州注册号",
  "FoodB_20250414_hanC_RXkJ": "P1*P2",
  "Gattaran_0_Role_QDBu": "角色",
  "Gattaran_V20__THMR": "商户等级",
  "Gattaran_form_xJkV_MADh": "备注",
  "FoodB_in_JvQz_jMAb": "上报异常",
  "FoodB_scenario_tWmb_Krny": "商家超时未接单",
  "Gattaran_0__ypdc": "在此区域加载",
  "FoodB_up20241218_Btbi_AOsy": "提交成功",
  "Gattaran_Gattaran_tXqW_GKCv": "正在执行",
  "Gattaran_REGULAR_TWeg_lFbm": "此为必填项",
  "FoodB_governance_OZDM_JqJt": "是否完成竞对比价整改",
  "FoodB_indicator_IPAg_AyWR": "数据统计周期",
  "Gattaran_management_adiS_UvoW": "无拜访任务",
  "Gattaran_material_fvgd_sjhQ": "审核失败：参考审核失败原因，请修改表单后重新提交审核",
  "Gattaran_Page_Distance_jPzG": "距离",
  "Gattaran_0_Menu_optimization_hWWT": "菜单优化",
  "FoodC_202408_uMeD_ECQU": "操作失败，请您重试",
  "Gattaran_form_MLcA_tPgo": "该字段是必填字段",
  "FoodB_requirement_puhp_VPIQ": "出餐超时订单量",
  "FoodB_20250612_SduQ_XghF": "必须输入1-10位数字",
  "Gattaran_202406_wGfZ_ewxp": "任务执行团队",
  "FoodB_scenario_Essn_oVjW": "对营销活动/费项有疑问",
  "FoodB_APP_BKjc_PGqI": "商户广告",
  "Internal_Tools_CRM_MiAT_UkNG": "取消",
  "FoodB_0905__zFVs": "总体权重",
  "FoodC_education_Platform_Delivery_MJPQ": "平台配送",
  "FoodB_management_Name_of_EjQd": "上级姓名",
  "FoodB_accompanyvisit_JkOw_BlRX": "BD是否能与客户分析和讨论服务水平的kpi（如“在线时长”和“取消率”），并提出实用的解决方案？",
  "Gattaran_mgt_Check_the_Zyhr": "查看参与考核的商家列表",
  "FoodC_202408_HNlI_lTpJ": "您还没有添加小费",
  "FoodC_dish_Look_again_fJrp": "再看看",
  "Gattaran_KPI_System_performance_cQiV": "系统绩效系数",
  "Gattaran_Visit_Change_2_mNNS": "改变2",
  "FoodB_accompanyvisit_dHvL_iRUP": "在陪访开始前和进行中BD是否熟练使用CRM系统？",
  "FoodC_nonaffiliate_Courier_is_iunG": "骑手正前往商家为您下单",
  "FoodB_20250414_dobD_hNij": "新客占比",
  "FoodB_page_UURy_Lqdt": "有一条新生成的拜访摘要",
  "Gattaran_Optimization_AFCF_zMMS": "支持给联系人拨打电话",
  "FoodC_202408_IBpM_TxlD": "其他",
  "必选": "必选",
  "FoodB_20250612_GGEs_TCgn": "必须输入10位数字",
  "FoodB_0707_High_prices_fBsL": "高价",
  "FoodB_process_kiMF_XkhA": "待确认",
  "Gattaran_0_Select_Contact_UrRS": "选择联系人",
  "Internal_Tools_App_oLpX_dbCU": "今天",
  "FoodB_0921__isZD": "合格率",
  "Internal_Tools_CRM_yMUu_NPxu": "请输入",
  "FoodB_1106_LmPI_RZuR": "未开启录音权限，请在设置中开启。",
  "FoodC_202409_yzRW_xKLM": "订单已关闭。如需查看详情，请输入下单人手机号",
  "Gattaran_feedback_Bkis_KqHN": "已提交反馈",
  "FoodB_20250414_faVK_FFkd": "比例",
  "Gattaran_transformation__zjbG": "签约主体ID",
  "bill-manage---no_auth": "暂无权限",
  "FoodB_Contract_nsIw_Gfzl": "{{brand_name}}价格{{unit}}{{number}}%竞对价格",
  "FoodB_Translation_kinT_foeX": "请选择处理失败原因",
  "Internal_Tools_CRM_roQc_QSuD": "联系电话",
  "FoodC_web_Application_Progress_UYtG": "申请进度",
  "Gattaran_202311_XTsd_OBZL": "距离该门店{{distance}}",
  "FoodB_1106_qhrP_Bevz": "做了什么工作？",
  "Internal_Tools_App_OKLc_fuyL": "近{{day}}天",
  "Gattaran_202406_PESn_Wyzj": "参考信息",
  "FoodB_accompanyvisit_BDpV_dijH": "是否清晰阐述了商业提案，突出了{{99}}相较于竞争对手的差异化优势，并有效传递了我们的价值主张？",
  "Gattaran_display_SDiW_jcDc": "该地址下其他商家如下",
  "FoodB_in_hlDP_KYHy": "获取定位失败，请在设置中打开定位，并允许{{appname}}使用定位服务",
  "FoodC_edit_GeFS_ZPLW": "建筑名称",
  "FoodB_feedback_KSnE_LLPJ": "收到您的反馈，请关注D-Chat消息和邮件感知最新进展",
  "Gattaran_form_wrkw_ybam": "目的",
  "FoodB_audit_Similarity_check_cQEP": "相似度校验",
  "FoodB_Translation_vZUg_djAJ": "请选择处理结果",
  "FoodC_202408_zoCD_Pszh": "继续",
  "FoodC_supplement_Return_wVpv": "返回",
  "FoodOpB_CRM_Taxpayer_full_fzhk": "纳税人全名(全国)",
  "FoodB_APP_kvLF_MMXl": "日完单量",
  "FoodB_Website_tNXH_hTaL": "请输入正确的手机号",
  "FoodB_calculator_yiXt_NkiM": "平台佣金率",
  "Internal_Tools_App_pdgP_UCoK": "通过手动输入定位",
  "FoodB_management_OqJO_eKyB": "请输入姓名",
  "FoodB_20231012_Usvn_HuCU": "任务创建成功，后续可在我的任务模块查看进展",
  "FoodB_feedback_aPoO_fIUh": "发生系统问题导致反馈提交失败，请通过下方的邮箱或D-Chat直接联系我们",
  "FoodB_20250122_cjEP_PzzB": "任务创建团队",
  "FoodB_page_TMuL_Jndl": "拜访目的",
  "FoodB_5_Store_Delivery_PIyN": "自配送",
  "FoodB_calculator_JGZb_tQiY": "用户实付价格",
  "Internal_Tools_0523_djkV_XXks": "已注册活动列表",
  "FoodB_indicators_DXHY_dobu": "经营指标",
  "FoodB_field_Do_you_mhOz": "是否需平台申报当地的税",
  "FoodB_B86_UdlE_SMWM": "确定",
  "Internal_Tools_App2_WfdX_XUIO": "已完成",
  "FoodB_calculator_pEyx_wJvY": "是",
  "FoodB_0820__bVDh": "高优门店",
  "Gattaran_page_jeoa_zoNR": "该商家还没有进行拜访，无法申请签约，如果已经完成拜访请填写拜访",
  "FoodB_in_hnnz_miyT": "签到失败",
  "FoodC_education_5_Cash_zBuY": "5. 如下现金支付订单，顾客需准备充足的现金，现金付款后取餐；",
  "Gattaran_0__ztLy": "反馈",
  "FoodB_management_Role_yLYi": "角色",
  "FoodB_CL_Traditional_companies_cQhK": "传统公司",
  "Internal_Tools_App_sneY_mCvo": "财务联系人姓名",
  "FoodB_accompanyvisit_PTCc_aqRn": "面对客户异议时，BD是否展现出情绪控制力、论证能力和说服力？",
  "Gattaran_0__Auzn": "拖动地图加载更多门店",
  "FoodB_B86_UDxy_zyJV": "该商户在当前周期内没有违规记录",
  "Internal_Tools_App_cbRv_idqO": "线索信息",
  "FoodOpB_CRM_Taxpayer_Tax_xOmZ": "纳税人税号 （当地）",
  "FoodC_202408_PvIX_VPCT": "登录后可查看专属优惠、跟踪订单状态",
  "Gattaran_Process20250815_RJzh_SzcB": "再次申请",
  "FoodB_1106_zQzq_GRVj": "本设备不支持录音",
  "FoodB_accompanyvisit_tKym_AVNz": "整体反馈",
  "FoodD_Name_August_cjQS": "八月",
  "FoodOpB_system_DiDi_XcUY": "DiDi经营",
  "Internal_Tools_App2_fjLr_RvMk": "数量超出提示",
  "FoodB_calculator_VFoE_zsGK": "菜品成本",
  "FoodB_v12_EuTn_cOWR": "集成商信息",
  "Gattaran_management_WjPM_jAvI": "发送协议给商家",
  "Internal_Tools_App2_QhIO_MwdW": "搜索油站名称/税号",
  "Gattaran_84_pFOg_DKGB": "违规内容",
  "FoodOpB_2_Activity_status_hKFd": "活动状态",
  "Gattaran_opt_klQH_BPVb": "商机信息",
  "FoodB_accompanyvisit_JAMs_lVxa": "BD是否展现了一名优秀销售员的核心技能，例如面对异议时的情绪控制力、论证能力、说服力以及精准的方案阐述能力？",
  "Gattaran_REGULAR_JVAQ_pbxi": "基础Input",
  "Gattaran_statusbar2_HSiT_INfG": "审批通过",
  "Gattaran_v2_meyK_ACyX": "支持跳转至{{DiDi_Top}}",
  "Internal_Tools_App2_FAVe_GEuM": "编辑计划",
  "Gattaran_20240902_XVee_UUPM": "该任务由于{{reason}}被{{account}}驳回，请登录GTR销售任务管理模块再次完善参考信息后提交",
  "FoodB_in_jXCJ_piNt": "是否确认提交照片？",
  "Gattaran_202406_lNdD_KvZI": "商家任务({{N}})",
  "Gattaran_V1_HNYI_VwLG": "商家未报名",
  "FoodB_collection_Tax_Classification_uJHT": "税制分类（全国）",
  "Gattaran_202406_FRwK_cCbx": "我的任务",
  "FoodB_APP_YjyK_hqYn": "订单",
  "FoodB_in_jecP_aEPa": "未打卡",
  "FoodB_accompanyvisit_whTV_IRlg": "在整个陪访中是否始终保持积极主动的工作状态，并在拜访期间展现出高效的组织协调能力与行动敏捷度（没有分心，真正专注于业绩）？",
  "FoodB_Optimization_QsfU_elzm": "请选择商家类型",
  "Gattaran_20250610_cwrB_uBlH": "请完善商家签约信息并且完成RTBO",
  "Internal_Tools_App_FCxp_ADxG": "营业时间",
  "FoodB_calculator_AioF_coBc": "个人VAT金额",
  "Internal_Tools_App2_kfaK_CNAM": "显示近一年内所记录的所有成本价格",
  "Gattaran_0_Marketing_activities_qANU": "营销活动",
  "FoodB_up20241218_hGVF_hBSj": "当前商家没有符合条件的菜品，建议你联系商家尽快上传菜品",
  "Gattaran_Project1_HXjY_OZWN": "佣金补贴冲突提示",
  "FoodC_dish_Leaving_LwWJ": "离开",
  "FoodB_CL_RUT_roUA": "RUT",
  "FoodC_202408_IfNx_VyNu": "已保存地址",
  "FoodB_optimization_Full_reduction_NlOa": "满减",
  "FoodC_dish_You_will_AXAT": "离开您将无法购买新人专享特价菜品",
  "Gattaran_add_WtmN_hzJP": "Connectivity>60%",
  "FoodB_v12_yorO_qIQQ": "是否有订单集成商",
  "FoodC_edit_NwrE_OHgM": "请在公寓楼外见面",
  "FoodB_data_End_mVwX": "结束时间",
  "FoodB_0327_ZGTe_zcKH": "点击这里可以切换城市",
  "Gattaran_0__NAOt": "请描述你的问题或建议并发送到下面的邮箱或直接通过D-Chat联系我们。",
  "Gattaran_visit_KjUG_kxHP": "BD列出了营销活动或研究了商家的需求",
  "FoodC_education_1_If_iWDm": "1. 如顾客未按照上述要求取餐，导致交餐纠纷，优先顾客承担责任，具体场景包括且不限于：",
  "FoodB_opencheck_Lqbg_GbON": "前往{{99app}}",
  "Gattaran_0509_PLgH_VDtS": "前10热销菜",
  "Gattaran_optimization_deWd_ffjJ": "最终绩效完成度",
  "Gattaran_0_Decision_makers_uOOG": "决策人（KP）",
  "FoodB_V2_No_legal_QONX": "无法人身份证ID",
  "FoodB_Commision_Type_of_EIWZ": "商户类型",
  "Gattaran_mgt_Unqualified_Store_JeWr": "未达标商家",
  "FoodB_Overview_AasD_LvfW": "查看更多",
  "FoodB_NewStore_Status_HphC": "状态",
  "Gattaran_20240401_kuua_DPLO": "暂时跳过",
  "FoodB_list_Store_Phone_tSWo": "门店电话",
  "Gattaran_visit_KNGQ_NwUQ": "BD列出了之前的共识、解决方案",
  "Gattaran_opt2_kPIo_ZpuU": "自配送单量(每周)",
  "FoodB_communications_mtxm_YcRA": "门店未完成新店成长任务",
  "FoodB_V1_zSAb_YlGe": "剩余{{num_days_left}}天",
  "Gattaran_84_BAfy_jvHS": "违规ID",
  "Gattaran_management_Associated_New_iDiy": "关联新门店",
  "Gattaran_202406_HnXs_yYCh": "任务状态",
  "Gattaran_form_wuYy_lqzb": "平台信息",
  "Gattaran_management_HgTV_cHfW": "添加计划",
  "Gattaran_B86_AJdW_BXRv": "{{number}}月在线时长率",
  "Gattaran_jumppromo_ONbQ_nOEB": "营销数据看板",
  "FoodB_420241024_LTYv_GOfN": "实际值",
  "FoodB_optimization_Label_nzNw": "标签",
  "FoodB_process_EHJE_CoxL": "选择子菜",
  "FoodB_P0_cNyW_HkyE": "完单变化量",
  "FoodC_edit_OVRs_CzUt": "酒店",
  "FoodB_20230410_YNjt_xAWA": "优选好店",
  "FoodB_management_sSVO_Bizb": "是否删除联系人？",
  "Gattaran_optimization_MwZK_gJdn": "指标激励",
  "FoodB_Side_YfKV_vTcN": "高峰时段在线率",
  "Internal_Tools_App_tpZf_wbHM": "主要联系人",
  "FoodOpB_Tool_Visit_szxD": "访问链接",
  "FoodC_202408_leda_oOpl": "轻松跟踪订单",
  "Internal_Tools_App2_XBvf_vJDB": "检查",
  "FoodB_V1_LADl_QUme": "填写表单",
  "FoodB_list_Setting_Up_YlBy": "设置在线时长",
  "Gattaran_84_IIJR_tPfw": "识别方式",
  "FoodB_1106_Boir_tlSu": "您的语音文件上传失败，请确保网络畅通或检查您的文件大小不超过5兆、录音时长不超过{{max_record_time}}秒。",
  "Gattaran_statusbar2_Pfzu_ihne": "审批中",
  "Gattaran_opt_SsHX_vUuN": "售罄取消",
  "Gattaran_schedule_saMI_wHLe": "可以一键生成线下拜访路线啦！",
  "sailing.d-api.common.页面获取失败，请稍后重试": "页面获取失败，请稍后重试",
  "Gattaran_V2_TtYW_lonJ": "当前数据时间{{update_time}}，数据延时1-2小时更新",
  "Internal_Tools_App2_bcHq_KppB": "待拜访",
  "Gattaran_0_Merchant_activities_wwGb": "招商活动",
  "Gattaran_Translation_Alien_ID_IMja": "外国人身份证",
  "soda-c-i18n---当前订单（不含已取消订单）未在预计送达时间内送达，%s将赔付给您一定金额的优惠券，订单完成后可以在": "当前订单（不含已取消订单）未在预计送达时间内送达，%s将赔付给你一定金额的优惠券，订单完成后可以在",
  "Internal_Tools_App_Prgi_JgdZ": "确认",
  "FoodB_APP_PJrW_uBye": "AOP/ASP",
  "FoodB_V1_CLCC_nUuk": "创建拜访",
  "FoodB_I_Home_OrRo": "首页",
  "FoodB_collection_Taxpayer_Information_fQid": "纳税人信息查询",
  "FoodC_202408_GeGr_xwdt": "配送联系更便捷",
  "Gattaran_202406_cPQJ_uCFE": "任务类型",
  "FoodB_comparison_FSKj_kcIf": "比较结果正在审核中",
  "FoodOpB_information_The_selected_LyoI": "所选银行不支持结算",
  "FoodD_Name_September_Ezci": "九月",
  "FoodC_202408_xwYJ_IzdZ": "继续",
  "Gattaran_V2_Vjbt_glNA": "报名活动",
  "FoodC_web_Customer_Service_EBqf": "客服",
  "FoodB_opencheck_GlFW_TclW": "前往查看",
  "FoodB_0_Mail_SUKZ": "邮件",
  "Internal_Tools_App_LlZj_XSVI": "创建拜访",
  "Gattaran_202406_ndOn_KPLE": "任务详情",
  "Gattaran_opt2_Nngy_DhyN": "审核状态已过期，此处无法查询。请联系相关产品负责人",
  "FoodB_accompanyvisit_dhas_ATCp": "是否能通过探询性提问和主动倾听来确认餐厅的现状与挑战？",
  "FoodB_calculator_VujK_GJbV": "利润",
  "Gattaran_Visit_Accompanied_visitors_ZFNA": "被陪访人",
  "Internal_Tools_App2_BEqX_EVvQ": "周五",
  "FoodB_calculator_mTaD_pjZv": "总折扣金额",
  "Gattaran_0_Improved_Cancellation_KpWF": "改善取消率",
  "Gattaran_V2_nmOG_KwMG": "活动报名菜品数量要求",
  "Gattaran_Visit_Before_visiting_VHLe": "拜访前",
  "Gattaran_mgt_Display_all_Yagb": "默认展示所有未达标的商家及其指标",
  "Gattaran_store_nPds_FcDF": "当前页面不是正式的签约入口；为了您的权益和信息安全，请前往正式入口完成签约。",
  "FoodC_1_mnqk_AcOb": "复制失败",
  "FoodB_in_ZfQl_HqDL": "已打卡",
  "FoodB_CL_Amount_CLP_Tmnv": "金额（CLP）",
  "Gattaran_84_fTVF_JwVK": "一般违规",
  "FoodC_202408_ZOBi_xjfW": "搜索地址，如建筑物或公寓名称",
  "FoodOpB_CO_Not_applicable_WuPn": "不适用",
  "FoodC_supplement_Modify_Mobile_ZJkT": "修改手机号/修改密码/绑定邮箱/注销账户请",
  "FoodC_address_gNYi_HdzX": "保存失败",
  "FoodD_supplement_Rules_RYAa": "规则",
  "FoodB_email_qCka_NBMf": "倾向联系时间",
  "Internal_Tools_App_qybY_jcAh": "ERP系统",
  "FoodB_tagging_You_chose_DSiT": "您选择了无效商机原因：停止营业，必需填写照片或KP电话任意一项！\t\n",
  "Gattaran_opt_cUSL_RSNr": "地图导航&查看联系方式",
  "Gattaran_form_YzJW_ggnb": "商家经营信息",
  "FoodB_0919__YKYU": "非营销",
  "FoodB_calculator_mdtN_KpDW": "总折扣",
  "Gattaran_202406_jIoA_BlIm": "展示维度",
  "FoodB_page_soIL_UjnD": "去重试",
  "FoodB_survey_zzNV_gkFf": "备注",
  "FoodD_up_DiDi_Delivery_FdmM": "滴滴配送",
  "FoodC_202408_pSzr_CJqz": "保存地址",
  "Gattaran_management_hCqr_uwez": "编辑邮件",
  "FoodC_202412_JiED_bPrx": "未找到地址，请输入正确的建筑物、街道和门牌号",
  "Gattaran_0_Operating_channels_upHR": "每日订单",
  "FoodB_20250414_EVlU_bloy": "新客人数",
  "Gattaran_AlertV1_FkFa_EQiG": "暂时没有符合条件的商家",
  "FoodB_V1_BEKq_hBNG": "已筛选：{{tag_name}}",
  "FoodB_accompanyvisit_mOOJ_zFjt": "是否积极接受陪访中的反馈，并展现出明确的改进意愿？",
  "FoodC_1_ScPa_MVPN": "复制成功",
  "FoodB_management_ZwFz_QsoN": "添加联系人",
  "Gattaran_management_BjBQ_GVEr": "{{num1}}/{{num2}}线下拜访完成度·{{month}}",
  "Gattaran_REGULAR_ezuA_ZuBN": "税号",
  "FoodB_in_qJcB_oRfE": "打卡时间过短，您确定要签退吗？这不会影响您的绩效。",
  "FoodC_all_You_haven_lSmt": "你还没有邀请你的朋友，快去邀请他们吧",
  "FoodB_calculator_rMFF_EMXI": "现金",
  "Internal_Tools_App2_MoBn_DHqJ": "删除",
  "Gattaran_AlertV1_MmvI_acwe": "剩余{{date}}天",
  "Gattaran_Process20250815_enQA_qfXI": "查看详情",
  "FoodB_Translation_IcyT_qdIf": "待整改",
  "FoodB_scenario_PuLv_FhUL": "其他方发起的B责取消",
  "Gattaran_mgt_Without_search_XVsz": "无搜索结果，可调整筛选条件后再次尝试",
  "FoodB_20250414_WmJY_oZbB": "漏斗",
  "FoodB_calculator_HfHr_bkLf": "平台补贴折扣的部分",
  "FoodC_education__3_TDsa": "（3）顾客拒收餐品",
  "FoodB_B86_xkRX_bJPm": "违规信息准确吗？",
  "Internal_Tools_App_GMMl_xksG": "银行名称",
  "FoodB_1106_tTbZ_mKRW": "AI分析",
  "FoodB_Launch_DR_ID_AnVk": "DO-身份证",
  "Gattaran_management_oCmv_JtTy": "滴滴协议",
  "FoodB_CL_Vista_Account_QcOm": "Vista账户",
  "Gattaran_BDapp_Rvoe_RUHw": "BD门户（普通）",
  "FoodB_I_onwf_oaQH": "活动销售额",
  "FoodB_process_keoD_znIy": "未匹配上菜品",
  "FoodB_indicator_gkdu_HwLc": "核心经营指标",
  "soda-c-i18n---订单实际送达时间晚于预计送达时间%s分钟以上，": "订单实际送达时间晚于预计送达时间%s分钟以上，",
  "soda-c-i18n---取消订单": "取消订单",
  "请选择支付方式": "选择支付方式",
  "Internal_Tools_App_Qgai_eoNp": "品牌",
  "Gattaran_KPI_ioIq_fNJB": "该商家首次在线时间",
  "Gattaran_Feedback__dWQe": "处理人",
  "FoodB_progress_ZdQT_mHfK": "重置",
  "FoodB_calculator_Jryi_aded": "税务主体",
  "Internal_Tools_App_rOKe_yMwP": "ERP状态",
  "Gattaran_jumppromo_vqdm_KQKO": "点击跳转营销数据看板，查看更多数据详情",
  "FoodD_Optimization_ppct_mVEc": "请输入手机号",
  "Gattaran_url20250708_paYw_lmmU": "菜单链接参考",
  "Internal_Tools_App_gUvZ_AiZQ": "拜访信息",
  "FoodB_0_Please_upload_dcPG": "请上传短信记录截屏",
  "FoodC_dish_Are_you_TaUN": "确认离开吗？",
  "Internal_Tools_0510_DBOY_ADvH": "未设置节假日营业时间",
  "FoodB_CL_Add_any_egRn": "请添加上传以下三种文件中的任意一种即可：法定代表人授权书、圣地亚哥（或相关城市）商业登记、更新状态证书",
  "FoodB_20250612_jtyZ_DrEC": "店主的朋友/家人",
  "FoodB_0617_rPjX_pvuu": "餐厅接受通过WhatsApp或电话订餐吗？",
  "FoodB_scenario_FkIm_wbyt": "店铺太忙无法出餐",
  "Internal_Tools_App2_lQcx_yrtq": "添加计划",
  "Gattaran_form_FtqP_caNF": "拜访目的",
  "FoodC_202412_aCvV_UNyj": "添加新地址",
  "Gattaran_Visit_Results_ftOU": "结果",
  "Gattaran_0_Improvement_of_TPKB": "改善差评率",
  "FoodC_web_Feedback_on_ookM": "网页版暂不支持相关问题的反馈，请您前往手机应用中进行操作。抱歉给您造成了不好的体验，如您仍有疑问，请联系客服帮您解决。",
  "FoodB_0830__wEQD": "本月完单量",
  "FoodB_in_mOVo_WHCx": "请保证您和商家门牌同时在照片中露出，并确保清晰、完整",
  "FoodB_1106_OZBo_RTDB": "客户意向",
  "Gattaran_side__vcvR": "星期日",
  "Gattaran_84_Uwcd_PIjN": "{{brand}}价格",
  "Internal_Tools_App_GiyX_Jwmf": "添加拜访记录",
  "Gattaran_opt_AGTs_VRUG": "较上期增加{{change}}",
  "FoodB_APP_alxj_KuRF": "进行中的活动",
  "Internal_Tools_CRM_qtMC_roJU": "油站",
  "Internal_Tools_App_LMjQ_TQFW": "当前位置距油站：{{Distance}}",
  "Gattaran_202406_iXbv_CcJq": "任务基础信息",
  "Internal_Tools_App2_ZjjL_OoOa": "详情",
  "FoodB_email_FvUP_tJQT": "姓名",
  "FoodB_CL_Maximum_amount_oflZ": "单次最大扣费金额（CLP）",
  "Gattaran_Visit_Date_of_TyAN": "陪访日期",
  "FoodC_popup_After_closing_ujoW": "关闭后您将无法保存已选择的菜品和规格",
  "Gattaran_management_nGle_XtpC": "商家邮箱",
  "FoodB_opencheck_BEoy_GUyq": "请确认商家是否下载{{99Store}}",
  "Internal_Tools_App_vJec_vZqL": "Swift代码",
  "Internal_Tools_App_VzrE_Uvmn": "油站名称",
  "Gattaran_Visit_Getting_ready_zDyf": "准备工作",
  "FoodOpB_management_Launching_HwsY": "展开",
  "Gattaran_management_IEaM_OfwD": "联系人称谓",
  "GDriver_trans_seconds_fFsz": "秒",
  "FoodB_I_QuSz_HsAZ": "营销力度",
  "FoodB_sob_dQvJ_WRCM": "绑定SOB账号",
  "Gattaran_mgt_No_performance_GzjE": "暂无绩效数据",
  "FoodB_accompanyvisit_WoFg_gLDx": "是否能根据决策者特点灵活调整语言和沟通方式，建立真诚的信任关系？",
  "Internal_Tools_App_FiXW_DMEF": "拉新中",
  "Gattaran_0229_SpOD_JZZs": "可能是由于您在DiDi合作、线下、DiDi经营内选择了互斥的筛选条件。",
  "FoodB_audit_The_information_jxLV": "您提交的信息不满足",
  "FoodC_Notification_ZawA_BoKt": "查看全部进行中订单",
  "FoodB_420241024_TFhQ_lSww": "驳回成功",
  "FoodB_optimizing_Duplicate_Store_aBYS": "重复门店ID",
  "FoodB_report_DLbK_IWIH": "地址错误？",
  "Gattaran_202406_QyVz_DlrH": "任务优先级",
  "FoodC_202412_Afcx_fMwc": "选择地址",
  "Gattaran_V2_XHhz_OxUM": "任务时间",
  "FoodB_APP_eiHc_XFQQ": "营销占比",
  "Gattaran_Visit_Visit_process_dZws": "拜访过程",
  "FoodB_1106_Ezht_DXlH": "文件大小不能超过5MB",
  "FoodB_page_LVCK_ZWBK": "完成",
  "FoodB_process_ziFN_pEHW": "截止昨天RTBO完成进度",
  "Internal_Tools_App2_ALgE_nywC": "结果：{{result}}",
  "FoodB_in_HOiz_LgJT": "提交",
  "FoodB_V1_vKqg_VkFI": "项目列表",
  "Gattaran_Top_gxPb_uTLM": "3.商家一旦成为DiDi Top，则会得到一定流量权益，对于提升单量大有益处，所以努力帮助你的商家成为DiDi Top吧",
  "FoodB_survey_CEvs_qbnA": "竞对佣金比例-P",
  "FoodB_email_SHyg_fIzy": "邮箱为空，请先补充后才能发送邮件",
  "FoodC_202412_enwa_nWfu": "菜品已售罄，看看其他菜品吧",
  "Internal_Tools_CRM_sYtz_hQDA": "油站名称",
  "Gattaran_url_TmcA_KzBM": "{{Uber}}菜单链接",
  "Gattaran_material_javG_HxIv": "当前拜访方式下可以执行的任务",
  "Gattaran_transformation__sLrG": "当前主体下有商机在审核中，审核通过后可签约",
  "FoodOpB_1_There_may_scoc": "计划时间可能存在冲突，该日计划如下：",
  "FoodB_sob_cDKJ_oFcF": "绑定成功",
  "Internal_Tools_App_TDqq_hkdP": "油品种类",
  "Gattaran_0_Create_new_Faau": "新建联系人",
  "FoodOpB_1_Are_you_sLNY": "确定关闭本次拜访？关闭后拜访失效不可录入",
  "FoodC_edit_KDUB_nVRR": "必填",
  "FoodB_opencheck_XqjA_alBe": "已完成",
  "FoodB_Contract_adlR_lBNU": "是否成功上传审核通过的堂食菜单",
  "Gattaran_V2_DwZk_joic": "任务名称",
  "Internal_Tools_0523_XvOO_ugWO": "已注册，查看详情",
  "Gattaran_management_lLpT_dFdN": "未拜访",
  "Gattaran_visit_jnPQ_METw": "店主是否在店",
  "Gattaran_202406_CvwH_Obyc": "任务截止时间",
  "FoodOpB_results_The_key_HHMa": "关键目标不在店铺",
  "Gattaran_Feedback__WUQR": "我的反馈",
  "FoodOpB_1_A_recent_LtIi": "已有近期未完成的拜访计划，是否继续录入？",
  "Internal_Tools_App_skNg_IIIe": "否",
  "Internal_Tools_App_qOUi_WmVg": "纬度",
  "Gattaran_V20__eJGq": "商机等级",
  "Gattaran_optimization_qReN_wCHB": "本月的拜访任务已更新，立即查看",
  "FoodB_email_Zgsh_mNSy": "KP",
  "Gattaran_form_rWtU_nHko": "请选择",
  "FoodB_optimization_Special_Meal_YtqD": "特价菜",
  "Gattaran_0_Prices_of_kkXs": "滴滴相对于线下菜单的价格",
  "FoodC_20240607_hfCf_kdpO": "电话",
  "Internal_Tools_App_sXad_CZPU": "地区和语言",
  "FoodB_task_UZKM_xysG": "当前值",
  "Gattaran_84_qedy_lUwd": "违规等级",
  "Groceries_web__Ovnh": "抱歉，商超店铺目前只支持在app端查看",
  "FoodB_IGV_WGYF_kfvV": "增值税",
  "Gattaran_opt_AIBq_AcbH": "编辑商机信息",
  "Gattaran_status_Ozec_ScYy": "待修改",
  "FoodB_1106_dhXS_LAAs": "AI总结生成失败",
  "Gattaran_form_MhMj_Wboc": "添加平台信息",
  "已选择": "已选择",
  "FoodC_edit_stZr_IBeA": "其他",
  "FoodC_edit_AxtX_PAiY": "例如：C栋1118",
  "FoodOpC_backend_Urban_hhdx": "城市",
  "FoodOpB_app_Need_to_XZYr": "需要线下拜访",
  "Gattaran_opt_bWcH_ShAH": "添加计划",
  "FoodB_Analysis_Yesterday_nearly_aBCt": "昨天",
  "FoodB_calculator_ULXU_HjOF": "增值税税率",
  "Internal_Tools_App_cuvl_RIgb": "退出确认",
  "FoodB_calculator_WKKD_DbHM": "电子支付的应税金额",
  "FoodB_opencheck_ZCLB_lZeJ": "菜单&价格",
  "Gattaran_V2_CRUc_Yeyn": "活动详情",
  "FoodB_process_fSqQ_sYNN": "请输入菜品名称",
  "FoodB_opencheck_JIkE_hhmG": "地址信息",
  "FoodD_Questionnaire_Finished_YvLk": "完成",
  "FoodB_030_fqBt_uzDV": "该城市缺少城市权限：{{City}}，请在Gattaran申请权限",
  "FoodB_1106_Jvwt_cvqA": "上传录音文件",
  "Gattaran_management_tfXo_jhuS": "任务状态",
  "Gattaran_V2_XzcI_uroK": "活动名称",
  "Gattaran_opt_CjOE_rGuI": "查看更多拜访信息",
  "Internal_Tools_CRM_lbMF_fwNr": "主要联系人姓名",
  "soda-c-i18n---早间：%s-%s": "早间：%s-%s",
  "FoodD_Orders_Can_not_fkHK": "开始时间不能大于等于结束时间",
  "FoodB_data_Beginning_PbJC": "开始时间",
  "FoodOpB_Translation_Cash_accounts_fSLJ": "现金账户",
  "Fleet_tool_Search_sFMa": "搜索",
  "FoodB_management_diEN_EjtS": "门店经理",
  "FoodC_orderlist_Completed_Xuod": "已完成",
  "FoodB_B86_vHgx_eMOl": "当前问题",
  "FoodOpB_tagging_Non_retail_JnDS": "不是一家餐厅",
  "FoodB_scenario_DYVH_kYTv": "近7日B责取消单量",
  "Gattaran_0__diqD": "没有门店",
  "Internal_Tools_CRM_VRWr_pCnt": "普通销售",
  "FoodB_1106_ZAuG_REFT": "请问您是否确认关闭并退出？若退出则录音中断，内容不会被保存",
  "Gattaran_Visit_Empathy_and_CvFh": "同理心和谈判初期",
  "Gattaran_0_Clerk_call_fhnx": "店员电话",
  "FoodB_scenario_iTKN_qRYT": "订单超出配送范围",
  "Gattaran_20240409_JERr_RtyH": "查看全部商家",
  "Gattaran_AlertV1_MVye_ihrr": "当前绩效系数",
  "FoodB_1106_BLKp_thZN": "跟进信息",
  "FoodB_opencheck_kRqA_FpQO": "打印机&小票",
  "FoodB_accompanyvisit_lUAu_lYme": "职业素养与接洽方式",
  "FoodOpC_system_Business_hours_coEs": "营业时间",
  "Gattaran_form_TTAw_lJPb": "可输入备注作为补充信息",
  "FoodB_calculator_HXix_qhAK": "个人ISR金额",
  "FoodB_page_cium_rzWL": "点击录入语音智能生成拜访摘要",
  "FoodB_indicator_cGGf_oMTT": "指标数值",
  "FoodC_202408_reKH_lclj": "添加收餐地址",
  "Gattaran_cancelation_vqja_qihk": "请选择",
  "FoodB_scenario_cDgW_SOLZ": "近7日B责取消率",
  "Gattaran_mgt_Achievement_GuwU": "达标",
  "Gattaran_Visit_Business_feedback_Llza": "业务反馈对话",
  "FoodB_phrase__PWcd": "无已结束的营销活动",
  "GDriver_Rate_Mkpg_QdjY": "合作费用策略",
  "FoodB_1106_bquQ_ajOd": "文字录入",
  "Gattaran_opt_ZCLf_SEBU": "门店ID",
  "GDriver_demand__ILlE": "已下架",
  "FoodB_optimization_Not_started_XTpL": "未开始",
  "FoodB_email_wMIf_SGNM": "联系人称谓",
  "Internal_Tools_App2_bbEY_frCr": "是否确认删除？",
  "Gattaran_20240902_YGUw_avxA": "驳回",
  "FoodC_replace_Clear_Filter_iwTY": "清空筛选器",
  "FoodB_030_SQUQ_YDRS": "非我的门店",
  "Gattaran_add_bXDc_IEuz": "Connectivity(Daily average)>60%",
  "FoodB_governance_OCvE_wAPt": "去处理",
  "FoodB_Translation_JSTh_Vrzb": "详细申诉原因",
  "FoodB_management_csuF_MCdo": "请输入正确的邮箱地址",
  "Gattaran_online_HStX_yFLt": "首次在线时间",
  "FoodB_0622_Increase_store_kZfr": "增加门店对比",
  "FoodB_calculator_GdDU_bFgc": "平台补贴金额",
  "Gattaran_side__nJvf": "星期三",
  "FoodOpB_CRM_Party_B_BCQp": "乙方企业注册号",
  "Gattaran_REGULAR_XlOa_yzqB": "Output",
  "FoodOpB_crm_Business_model_wjXI": "业态",
  "FoodB_indicator_nLPV_KIjh": "当前分值",
  "FoodB_calculator_BKfQ_ehtA": "平台佣金",
  "FoodB_page_YwxF_xrtk": "录音上传过程中请不要退出页面，退出后本次结果将不会保存",
  "FoodB_email_SdUD_YAhg": "信息为空，请先补充后才能发送邮件",
  "FoodB_1106_XrIH_sjvu": "很抱歉，您的记录AI分析失败了。",
  "FoodB_0617_qTmE_PWeM": "餐厅每天通过店内取货处理多少订单？",
  "FoodB_process_vjLl_iVPp": "审核驳回",
  "Internal_Tools_App_xWMr_AnaW": "打电话",
  "FoodB_accompanyvisit_wQpj_fUwf": "请评价BD是如何进行销售的：是否很好地识别了痛点、清晰地呈现了提案，并有把握地引导至交易达成？",
  "FoodB_accompanyvisit_eQAg_imAj": "BD在与合作伙伴互动时是否展现出可靠自信与专业姿态？",
  "FoodC_20240607_Upph_ldoj": "购买提醒",
  "FoodB_calculator_VKAb_KHst": "平台补贴占比",
  "FoodD_Name_May_zYiz": "五月",
  "FoodB_list_KP_Name_GQRs": "KP姓名",
  "Gattaran_statusbar2_zVad_yPpm": "审批失败",
  "Gattaran_20240409_cmyA_kTJa": "报名中{{num}}",
  "Gattaran_jumpnewstore_kzko_qHFR": "点击查看流量数据",
  "FoodB_communications_APfO_DcRl": "新店成长任务未完成",
  "Gattaran_20240409_krBB_ZQnQ": "未开始{{num}}",
  "Gattaran_management_HNXE_vNoU": "任务ID",
  "Gattaran_status_pAhA_kENZ": "待审核",
  "FoodC_edit_JdIz_uKvw": "在外面见面",
  "FoodC_education_In_order_SRIb": "为了使您在{{brand_name}}服务中有更好的体验，平台特制订取消规则，以供各方遵守。",
  "FoodB_Show_Taxpayer_Document_eadz": "纳税人证件类型（当地）",
  "FoodB_scenario_czrv_MZIJ": "菜单需要更新",
  "Gattaran_opt_Qotr_nHZK": "经营数据",
  "Gattaran_v1_pVFJ_UAfK": "为商户报名招商活动",
  "FoodC_202408_LBac_RLgP": "请添加你的收餐地址，以方便骑手为您送餐",
  "FoodOpB_center_Rejection_FiOu": "驳回",
  "Gattaran_management_SqSM_FwHJ": "已拜访",
  "Gattaran_feedback_Xihz_dCuZ": "未完成反馈",
  "Gattaran_statusbar2_QQFK_mEcw": "审批",
  "FoodC_202408_BsWi_bWTi": "编辑地址",
  "FoodB_1106_hYOE_wfgV": "预览识别结果",
  "FoodC_202408_LtuD_oTxz": "取消",
  "FoodB_V1_hqNE_fQDz": "项目",
  "FoodC_sales_If_the_TsPm": "如果外包装有封条或其他密封工具（如装订针等），请您告诉我们收餐时它们是否完好。信息仅用于平台更准确地与商家和骑手核实您的问题，信息不会影响对您的处理结果",
  "Internal_Tools_App_kPwc_tSpo": "信息尚未保存，确认要离开吗？",
  "FoodB_Analysis_Nearly_7_wumh": "近{{day}}天",
  "FoodB_2_During_the_QHhU": "活动时间",
  "Gattaran_202406_ODsG_JrEY": "任务待完成",
  "Gattaran_Visit_Formula_item_xqos": "公式=（事项1得分/4+事项2得分/4+...）/事项个数*100%",
  "FoodB_process_WMCl_eXXl": "申诉中",
  "Gattaran_ES_ZfMz_IKyd": "在线率",
  "FoodC_education__2_uVUK": "（2）因商家未营业、商品售罄、发生意外等原因订单被商家或骑手取消，订单费用将全部退回；",
  "Gattaran_transformation__AByw": "签约主体类型",
  "FoodB_V1_VKlO_UPTE": "项目描述",
  "FoodB_orders_Select_Store_gtmG": "选择门店",
  "Internal_Tools_App_iieD_DElO": "税号：{{Tax_id}}",
  "FoodB_audit_Suspected_duplicate_ntLx": "疑似重复门店",
  "Internal_Tools_App_Qhjz_HpXk": "经度：{{lat}}",
  "Gattaran_202406_VqOU_hMFa": "任务类型标签",
  "Gattaran_202406_CltK_IQGG": "创建的（{{N}}）",
  "FoodB_Optimization_LfPz_zDPq": "填写开店检查项",
  "Gattaran_AlertV1_yVMN_aZdo": "重点关注的商家",
  "FoodB_Show_Taxpayer_Document_TFeg": "纳税人证件类型（全国）",
  "Gattaran_0_App_Operator_ikIT": "App操作员",
  "Gattaran_202406_ztqf_jOPK": "未完成",
  "Gattaran_202406_dDeL_ULkW": "去查看",
  "FoodB_Contract_yBjK_Ngdm": "签约协议是否为独家",
  "Gattaran_function__vJQK": "当前已是最新版本",
  "Gattaran_cancelation_ytQo_VUhl": "{{N}}个任务已执行",
  "FoodB_1106_dvab_aMNJ": "提交",
  "FoodB_report_CVHi_kjAP": "商家位置",
  "FoodB_accompanyvisit_QoJr_HduH": "请评价BD是如何执行商业流程的：包括指标解读能力、谈判技巧以及工具运用的熟练程度。",
  "FoodB_opencheck_pkQS_Jxyo": "二次检查",
  "FoodB_2_UTCg_iJFB": "系统未检测到商家订单，是否仍确认完成二次检查？（提交后将有人工进行审核）",
  "Gattaran_visit_hZGE_sfuk": "整体反馈",
  "Gattaran_Optimization_SGMS_fnOQ": "前往DiDi Food",
  "Gattaran_form_YnWW_YxTG": "添加联系人",
  "FoodB_2503_JeQk_FWxd": "加载中...",
  "FoodB_optimization_Buy_gifts_daUI": "买赠",
  "Gattaran_material_DYNa_ciax": "任务审核状态",
  "Gattaran_opt_EFMf_fxMF": "上次拜访",
  "FoodC_update_The_expected_ZzFg": "预计送达时间以平台预估的最晚预计送达时间为准。",
  "FoodB_pt1_ofEk_bcpz": "联系人邮箱",
  "FoodC_202408_BTvL_umes": "确定退出吗",
  "FoodB_B86_lRNJ_EMZv": "准确",
  "FoodB_v12_XWfx_gGrQ": "订单集成商名称",
  "FoodOpB_CRM_Taxpayer_Information_Flde": "纳税人信息附件照片（当地）",
  "FoodC_202408_ReqK_LVas": "确认",
  "Gattaran_V2_NgaM_BsXe": "活动简介",
  "Gattaran_opt_QCLu_UWmJ": "已取消的订单",
  "Gattaran_0_Can_t_zMtY": "联系不上",
  "FoodB_model20250116_HPUj_zcce": "获取定位失败，无法进行签到或者签退，请在手机“设置”模块打开定位开关，并且允许BDAPP使用定位服务",
  "FoodB_clockin_GfHc_jTsX": "打卡未填写拜访",
  "FoodB_420241024_rQXh_ONDO": "已达成",
  "FoodB_2_R_Burn_CgKc": "R burn",
  "FoodB_system_Competition_NFPY": "竞对",
  "Gattaran_84_yiob_OivQ": "黑色",
  "Gattaran_statusbar2_UQFc_DODT": "跟进中",
  "Gattaran_0_Publicity_cards_HSYt": "宣传牌",
  "Gattaran_management_fVhj_uFOo": "欢迎随时与我们沟通，谢谢！",
  "FoodB_management_Untied_tYEF": "解绑",
  "Gattaran_form_mvdB_WqwR": "添加接下来的行动",
  "Gattaran_visit_kYQA_ZYsK": "BD妥善处理了商家的异议",
  "Gattaran_mgt_System_recommended_AeDM": "系统推荐排序",
  "FoodB_opencheck_nxrN_OKDp": "请确保门店电话正确且可以打通，用于骑手和用户联系店铺",
  "Gattaran_status_AuAL_dKPA": "待拜访",
  "FoodB_B86_AADM_isyE": "取消",
  "FoodC_education__1_qvVC": "（1）顾客取餐超时",
  "soda-c-i18n---请告诉我们，帮助我们一起改善": "请告诉我们，帮助我们一起改善",
  "FoodB_calculator_RWNx_Xkrf": "个人",
  "Gattaran_optimation_QjMB_BOgo": "陪访表单页面意外退出，点击“重新打开”以再次进入上一次停留的页面。",
  "Gattaran_form_jbbp_rBPM": "离开",
  "Gattaran_transformation__hYxT": "关联签约主体",
  "Gattaran_Edition_oXdU_Hnsz": "我们没有找到你搜索的内容",
  "FoodB_process_nXaG_aweQ": "匹配详情页",
  "Internal_Tools_App_fEpS_WJta": "经度",
  "FoodB_V1_zPrX_zWoE": "R burn/GMV变化量",
  "FoodB_management_Sector_LRtz": "所属部门",
  "FoodB_0905__pNYF": "各订单类型有重叠，加和不等于当日完单量",
  "FoodB_1106_SvnP_rxzP": "完成",
  "FoodC_202408_XlDL_LjiM": "我知道了",
  "Gattaran_0_Price_management_rLvu": "价格管理",
  "FoodB_accompanyvisit_NWZA_xYGO": "评论一下BD是如何为陪访工作做准备的：是否目标明确、有效使用了CRM系统，以及是否在拜访中保持了战略聚焦？",
  "FoodB_0623_Store_GZFE": "门店",
  "Gattaran_opt_BEjW_mzFb": "首次在线后可查看数据报告",
  "FoodOpB_results_No_store_ZJQG": "无店铺有效联系方式",
  "FoodC_Website_DiDi_FoodDiDi_wtqn": "DiDi Food|滴滴外卖，随时随地享受美食！",
  "Gattaran_0_If_you_xGEs": "有未填写项，请完善信息",
  "FoodC_edit_dECN_fkIy": "请在写字楼外见面",
  "FoodOpB_crm_Takeaway_mode_UxEG": "外卖模式",
  "FoodC_202408_tJIe_WbFo": "取消",
  "Gattaran_workstation_zYPi_OfrB": "目标值",
  "FoodB_2__CkLu": "同城市",
  "FoodB_resivion_Inaccurate_information_dmRA": "信息不准确？",
  "FoodC_page__KWIm": "知道了",
  "FoodB_subsidy_tVNZ_GHKr": "温馨提示",
  "FoodB_0905__Uuug": "诊断规则",
  "FoodC_sidebar_Update_successfully_cuyI": "更新成功",
  "FoodB_process_eAKS_LYXf": "驳回",
  "FoodC_20240607_RSyh_XJnN": "请您用手机浏览器打开链接",
  "Gattaran_Visit_VrZq_Dgvh": "额外的机会",
  "Gattaran_feedback_wHFC_wkFP": "请输入具体原因",
  "Internal_Tools_App_iCHw_cRVH": "其它",
  "Gattaran_0_Visit_Registration_AZYL": "店铺采集信息",
  "Gattaran_0_Increase_social_MxxK": "为商家增加社交媒体",
  "FoodB_in_KrvJ_sgtQ": "您距离{{storename}}超过{{distance}}米，无法签到。可通过拍摄您和商家门牌的合影完成签到。",
  "FoodB_accompanyvisit_qeYs_vmCH": "优势",
  "FoodB_management_YBeV_ZPVJ": "姓名不能超过50个字符",
  "Internal_Tools_CRM_jrXd_olfC": "最佳拜访时间",
  "Internal_Tools_App_mzyX_fryx": "选择时间",
  "Gattaran_Optimization_IGsH_WCQM": "支持跳转到DiDi Food",
  "FoodB_V1_toMO_YDdz": "常规任务",
  "Gattaran_v2_LSlZ_XduF": "点击了解规则，助力商家成为{{DiDi_Top}}",
  "FoodB_0623_Indicators_auar": "指标",
  "Gattaran_20250610_poQp_BBLe": "待商家签约",
  "Gattaran_center__HcEx": "已将全部消息标记为已读",
  "Gattaran_page_zJGg_ZjcY": "请完善商家资质信息并申请签约",
  "FoodB_model20250116_GjAr_XZPC": "签到",
  "Gattaran_0__mpop": "请到App中打开或在D-Chat中搜索“Gattaran feedback”进群反馈",
  "FoodB_APP_WsXR_yQpy": "投资",
  "FoodOpB_Translation_Legal_persons_RduO": "法人",
  "FoodC_20240607_wWhy_deWR": "请刷新后重试",
  "Gattaran_management_WVOf_JOti": "查看",
  "Gattaran_material_WsIN_lrzh": "审核中：审核通过后任务会自动完成",
  "FoodB_1106_kpYX_BXVq": "分析",
  "Gattaran_optimation_MQrO_OvRt": "是否希望恢复页面？",
  "Gattaran_resivion_More_KTYU": "更多",
  "Internal_Tools_App_iRIy_dqLi": "本月",
  "Gattaran_B86_AQDt_AMVU": "{{number}}月B责取消率",
  "FoodC_switch_TFwP_lxTd": "默认小费说明",
  "FoodOpB_efficiency_Store_UpAc": "已签约商户数",
  "FoodB_tasktoteams_aXrr_bgrl": "自营接单服务日完单量",
  "Gattaran_V1_ZDXa_aTjw": "有效营销活动列表",
  "FoodB_0905__uatF": "高于同商圈{{number_or_rate}}商家",
  "Internal_Tools_App2_UCNH_VaOP": "今天",
  "Gattaran_202406_IIUg_NlxT": "商家信息",
  "FoodB_management_ouRt_eARK": "请选择角色",
  "FoodC_edit_wBJW_yfSo": "公寓",
  "Internal_Tools_App_BEnH_Yxgl": "最短查询范围是2天",
  "FoodC_20240607_aOOB_RMKm": "暂不支持现金",
  "FoodB_20250414_QcoH_HIDg": "全部用户",
  "Gattaran_202406_htDL_CJTB": "任务创建人",
  "FoodB_0905__kaPI": "诊断分数",
  "Gattaran_0__tWkQ": "特价菜",
  "FoodB_ads_WAjG_IoqX": "广告",
  "Gattaran_Optimization_cVHJ_PCUb": "点击展示商家营业时间明细",
  "soda-c-i18n---送您%s张免配送费券；": "送你%s张免配送费券；",
  "FoodB_supplement_Network_connection_RVcl": "网络连接失败，请检查网络设置",
  "FoodB_tagging_You_chose_tIKm": "您选择了无效商机原因为：店铺不存在，当前位置距离店铺大于{{distance}}，请检查！",
  "FoodB_task_idjV_gpOC": "任务已执行",
  "FoodB_accompanyvisit_qoYF_XrTD": "BD是否展现出自信的姿态、专业的商务话术以及谦逊但不傲慢的气场？",
  "FoodB_opencheck_HmpM_qXXX": "对于一址多店的商户，请检查在{{99store}}上的集成接单配置是否正确",
  "Gattaran_add_xwYd_UfEG": "logo",
  "FoodC_20240607_eLRx_hJRj": "暂不支持电脑访问",
  "Gattaran_Gattaran_wHVV_MQDY": "计划类型",
  "Gattaran_0_Contrast_the_YwEa": "与竟对平台对比降价",
  "FoodB_opencheck_azHm_SBan": "请确保用户侧展示的门店名称正确",
  "FoodC_edit_Hxmm_vrkU": "居民楼",
  "Gattaran_V1_gCzF_PJKj": "{{num}}个营销活动待跟进",
  "FoodB_tasktoteams_FSIB_Lmdl": "{{Rappi}}菜单链接",
  "FoodB_communications_ZlRD_aGjm": "剩余天数",
  "Gattaran_opt_xawD_vBtI": "日均在线时长",
  "Internal_Tools_App_oOyW_tZKN": "已下架",
  "FoodB_management_JCLV_lXux": "联系人信息",
  "FoodB_0617_UUYe_lgPA": "竞对佣金比例-R",
  "FoodOpB_1_Visit_dXVU": "拜访",
  "FoodB_0617_JNlE_tpzR": "竞对佣金比例-U",
  "Internal_Tools_CRM_ZxcL_MqnG": "采购价",
  "FoodB_leads_The_relationship_jkYA": "倾向联系时间",
  "FoodB_accompanyvisit_GMeg_eJaf": "在整个陪访中是否始终保持积极主动、有条不紊的工作状态，并在拜访期间高效利用时间优化整体表现？",
  "Gattaran_form_KjAJ_bymE": "拜访计划详情",
  "FoodB_page_Sbrx_Otpv": "确认要退出吗？退出后仅能通过端内消息查收本次分析结果。",
  "Gattaran_BDapp_Pder_myCx": "BD门户（CKA）",
  "Gattaran_feedback_tOgJ_GxDc": "上传图片（选填）",
  "FoodD_suspensionpage_In_the_zGEU": "到底了",
  "FoodC_202408_AFKG_hWIj": "超出配送范围了，请重新选择地址吧",
  "FoodOpB_StoreInput_Store_Information_mIjy": "门店KP信息",
  "FoodB_APP_hvLT_iISi": "每日最高投资额",
  "FoodC_perception_Tip_exceeds_VSFf": "小费超出额度限制",
  "FoodB_V2_Satisfied_with_YFEM": "对现状感到满意",
  "FoodB_Translation_vrHE_fstW": "整改成功",
  "Gattaran_84_eYqA_KQKL": "违规发生时间",
  "Gattaran_84_ipYl_XAMQ": "主体名称",
  "Gattaran_V2_tHSp_MfFU": "达标天数≥",
  "FoodB_group0901_KjSA_JaMq": "必做",
  "FoodB_accompanyvisit_csKl_ZhaN": "态度与表现",
  "Gattaran_0915__UZgP": "统计周期{{date1_date2}}",
  "FoodB_email_AhaC_FOft": "其他联系人",
  "FoodB_requirement_aAaC_nmQK": "高峰在线时长",
  "FoodB_Side_JVcJ_wJec": "营业时长",
  "FoodB_tagging_You_chose_lWSH": "您选择了无效商机原因为：非零售店铺，当前位置距离店铺大于{{distance}}，请检查！",
  "Gattaran_202406_JIgY_duWs": "收到的",
  "Internal_Tools_0523_ZlFL_LzUJ": "去注册",
  "FoodB_1106_UjEj_dsYG": "取消",
  "Gattaran_0_Not_willing_JFcK": "不愿意",
  "Internal_Tools_App_kYus_Rwmo": "电话号码",
  "FoodB_model20250116_PRsL_yJEl": "请至少选择{{num_required_fields}}个",
  "FoodB_v12_zpim_qhxP": "物流集成商名称",
  "Gattaran_84_SZSe_qxUU": "严重违规",
  "Gattaran_0__sDLK": "点击加载按钮查看更多门店",
  "FoodB_process_fmOQ_ZlAg": "未找到菜品",
  "FoodB_calculator_QGtY_JOsw": "商家投入折扣的部分",
  "Internal_Tools_App_giWs_FLQG": "输入备注作为补充信息",
  "Internal_Tools_App2_HKlO_Ulnq": "Percentile",
  "FoodB_page_VcqY_DnGG": "预计需要1～5分钟完成语义分析，请尽量不要退出该页面。若强制退出请留意端内消息通知获取本次分析结果",
  "FoodC_education_Basic_requirements_hIbv": "顾客取餐基本要求",
  "支付方式": "支付方式",
  "Gattaran_202311_WXzo_Yqns": "添加有效商机",
  "FoodOpB_Translation_Tax_ID_yEbh": "税号",
  "Gattaran_form_HuGK_YufB": "编辑拜访计划",
  "FoodB_scenario_TNIB_LZav": "店铺已打烊",
  "FoodB_Launch_Illegal_import_jlOS": "输入非法",
  "Gattaran_Collection__kwys": "地图页面支持发起导航啦",
  "FoodB_accompanyvisit_sotp_ppjT": "待改进之处",
  "FoodD_Name_November_BcWL": "十一月",
  "FoodB_GTR_MOcd_Ludv": "KA",
  "Internal_Tools_CRM_zbxK_LqJo": "税号",
  "FoodB_sob_rSPd_SAxs": "已绑定SOB",
  "FoodB_1106_ocKT_vZHR": "录音时长不能超过2分钟",
  "Gattaran_0_No_contacts_EeBR": "没有联系人",
  "Internal_Tools_CRM_LzIy_MlTO": "品牌",
  "FoodB_accompanyvisit_HBWN_qmUt": "接洽方式与信任建立",
  "FoodB_Wordings_MYHl_FXti": "选择原因",
  "Gattaran_opt_FWKd_AEaY": "点击输入线下经营信息",
  "FoodD_Incentive_In_progress_GNvs": "进行中",
  "Gattaran_84_VVSs_wTou": "堂食",
  "FoodB_2_Visit_Records_LiJy": "拜访记录",
  "FoodC_edit_fLUx_wHAP": "例如：我穿着花衬衫。还可上传您所在位置附近的参照物图，方便骑手准确送达。",
  "Internal_Tools_App_pcBI_HhnE": "重置",
  "FoodB_202204_Order_eJXF": "订单",
  "Gattaran_Visit_Fill_in_aFuS": "填写陪访",
  "FoodC_202408_KYqe_yVZD": "稍后处理",
  "FoodB_250430_kaeY_cgas": "拜访级别",
  "FoodC_edit_kzdk_yzVc": "请在房间门口见面",
  "FoodB_survey_IegO_JQod": "信用卡需求",
  "FoodC_edit_HEFc_Dppo": "请在我家楼外见面",
  "FoodB_store_Order_Coupon_zpSY": "下单返券",
  "FoodB_APP_RDdB_KQgY": "营销活动筛选",
  "FoodB_1106_fIyR_ECeB": "请输入内容",
  "Gattaran_visit_opSF_XPmM": "BD有明确的拜访目标",
  "FoodB_report_nayE_PYlR": "请选择正确的商家位置",
  "FoodB_calculator_Vzvw_WmgN": "付款方式",
  "Gattaran_20240409_JmCU_vNnz": "天后开始报名",
  "FoodC_202408_IDjR_CbbT": "确定",
  "FoodB_2_Call_visit_NGFu": "电话",
  "FoodB_I_Cancelled_orders_XeVk": "取消订单数",
  "FoodC_education_2_Receiving_gFZl": "2. 收餐地址、联系方式填写正确；",
  "FoodB_1__GxZN": "近30天的数据",
  "FoodB_B86_xxgH_gxNC": "错误",
  "FoodC_202412_AIDx_XZgz": "调整地址",
  "Gattaran_Feedback__amKQ": "高",
  "Gattaran_0_Is_it_uBZs": "是否是黑暗厨房",
  "Gattaran_0_Price_of_cdsJ": "滴滴相对于其他应用的价格",
  "Gattaran_V2_hSoR_bteQ": "可以代报名活动",
  "FoodB_APP_oNMt_RYzY": "去设置",
  "Gattaran_optimization__HjAa": "再次返回退出Explorer",
  "Internal_Tools_App2_zKCw_IMpc": "周六",
  "Internal_Tools_CRM_CqzP_fbCc": "城市",
  "Gattaran_form_MglG_FNNK": "拜访时间",
  "FoodOpB_Translation_ID_Card_jQZG": "身份证",
  "Gattaran_management_JcWN_FRMj": "与商家达成的协议",
  "FoodB_report_iSNH_AOiz": "请提交商家准确地址名称或坐标后再次提交",
  "FoodC_cash_WQNI_uYzC": "添加",
  "FoodB_opencheck_EgVo_aDIk": "请检查商家下是否存在一笔测试订单",
  "FoodB_collection_625_System_iWnH": "625-通过技术平台获得收入的商业活动制度",
  "FoodOpB_Org_Edit_Gphm": "编辑",
  "Gattaran_Optimization_ZhGy_ZlOk": "增加营业时间详情",
  "FoodB_0919__CONM": "下架菜品数",
  "FoodB_1106_CBkZ_uDVO": "下一步计划是什么？",
  "FoodB_scenario_HbKA_WhYt": "顾客原因取消",
  "FoodB_GTR_nRcI_TMWR": "CKA",
  "Gattaran_202406_EMkK_osti": "商家维度",
  "Internal_Tools_App_fJQz_FBzw": "近{{month}}月",
  "Internal_Tools_App_XqAW_HtbS": "实时价格",
  "FoodOpB_1_Plan_Nfsn": "计划中",
  "FoodB_V1_GLnG_kpoL": "项目任务",
  "Internal_Tools_CRM_nvDw_fHdG": "邮编",
  "FoodB_Commision_Cancel_wbtQ": "取消",
  "FoodC_education_4_Customers_laxR": "4. 顾客需要骑手到户后10分钟内及时取餐；",
  "FoodOpB_Management_You_can_aDLi": "您可通过点击“申诉”创建您的新店铺，预计需要等待2天时间可查看审核结果。",
  "FoodC_shop__MWyO": "该商品仅可购买{{num}}份",
  "FoodB_Translation_ycvD_ntAQ": "去申诉",
  "FoodB_in_nOzs_ZRGC": "签到成功",
  "FoodOpB_Org_Can_not_swrB": "删除后不可恢复，是否确认删除？",
  "FoodC_2022__SEQk": "输入小费",
  "FoodB_opencheck_fpzY_bDWB": "请确认配送方式与支付方式",
  "FoodB_0622_The_statistical_NUCJ": "数据统计口径为T+1，按照近30天菜品销量排序",
  "Gattaran_opt_OIIn_XXkw": "查看审核结果",
  "Gattaran_form_KvgC_Afkb": "退出确认",
  "Gattaran_V1_ZkCf_UOay": "清空",
  "FoodC_202410_OFhs_UnlA": "探索美味",
  "Gattaran_Edition_mvmO_sigb": "当前选择的日期与已存在的拜访计划重复，提交后会覆盖之前的拜访计划。",
  "FoodB_0921__iLXg": "数量",
  "Gattaran_20240401_iQeT_rFly": "感谢你的反馈",
  "Internal_Tools_App_Bufi_ZBrZ": "导航",
  "soda-c-i18n---送您1张%s折扣券；": "送你1张%s折扣券；",
  "FoodB_0919__etPs": "多种类营销",
  "FoodB_indicator_ONJL_riny": "分值",
  "FoodC_edit_EqUG_FRvo": "公寓名/楼层/房间号",
  "FoodB_calculator_lSyU_ySZI": "是否为瓜纳华托州商家",
  "Gattaran_material_GlUh_BTci": "任务表单",
  "FoodB_feedback_uLgw_xDsP": "反馈提交成功",
  "FoodOpB_management_Actual_value_dSKC": "实际值",
  "FoodB_202207_Default_BQmA": "默认",
  "FoodOpB_app_Collecting_documents_wTBe": "搜集文档中",
  "FoodB_V2_DQvR_Redp": "请在BDapp中使用分享功能。",
  "FoodC_optimization_knQx_VpIr": "添加",
  "Gattaran_V2_RfQR_GPmX": "任务指标说明",
  "FoodB_up20241218_dJSA_yyZX": "确认",
  "Gattaran_202406_Rqhc_vORg": "商家任务",
  "FoodB_scenario_cPkp_BcjZ": "骑手从未到店",
  "Gattaran_optimation_uLZP_VtyM": "重新打开",
  "FoodB_Translation_wHEO_FLQr": "申诉成功",
  "FoodB_page_ckUV_pmrw": "正在为您生成摘要",
  "Gattaran_mgt_All_SSzR": "全部",
  "Gattaran_202406_ObEK_ztcK": "该指标数据暂未完成计算，请明天查看",
  "Gattaran_form_pQiE_NLFe": "根据店铺诊断结果推荐的拜访目的",
  "Gattaran_page_kbBm_zDwh": "通过该入口签约，默认为本商家创建新主体且仅不支持纸质合同，如果您需要纸质合同或者和关联当前已有主体进行连锁签约，则请通过“GTR->客户管理->主体管理”页面进行签约。是否确认使用该签约入口？",
  "支付": "支付",
  "Gattaran_REGULAR_KZHa_qJOa": "请输入整数",
  "FoodB_IV_Tips_DFOG": "提示",
  "Gattaran_202406_kjmQ_Epeu": "创建的",
  "Gattaran_0_What_are_AWJz": "该区域发现的主要机会是什么",
  "FoodB_model20250116_pAHl_Vjqs": "审核不通过",
  "Gattaran_202406_NOiB_wJYW": "创建任务",
  "Internal_Tools_Optimization_KJgL_fWkX": "今日营业时间",
  "Gattaran_jumpnewstore_FJjw_JHRB": "新店成长-任务已完成",
  "FoodB_management_tvNC_ULVM": "WhatsApp号码",
  "Gattaran_Visit_Advantages_CSEp": "优势",
  "FoodC_Storefront_Fzba_uHgH": "无法参与",
  "FoodC_education_In_the_MKeB": "下列取消订单的情形下，您无需承担责任：",
  "FoodC_improve__ovBF": "份量少",
  "FoodB_accompanyvisit_ebrS_uKVQ": "得分详情",
  "FoodB_0617_RqaF_EHZE": "竞对独家合同到期日期-U",
  "Gattaran_0__ytbk": "高优",
  "FoodB_audit_New_and_yYux": "新旧店铺名称差异",
  "Gattaran_Visit_Related_Visit_RGas": "关联拜访记录",
  "Gattaran_side__OvkZ": "星期四",
  "FoodOpB_tagging_Store_does_sduq": "店铺不存在",
  "FoodC_education_In_order_AZCw": "为了使您在{{brand_name}}服务中有更好的体验，平台特制订取餐规则，以供各方遵守。涉及顾客取餐纠纷的场景，将按照如下规则处理",
  "FoodOpB_Gattaran_Reset_ILVf": "重置",
  "FoodB_1106_ZsZM_gMYt": "请按以下结构精炼叙述",
  "Gattaran_transformation__QWlQ": "请补充完整必填信息",
  "Gattaran_0__jRoM": "打开D-Chat",
  "FoodB_time_Business_hours_kRTs": "假期营业时间",
  "Gattaran_cancelation_Rcqm_Vawt": "任务相关拜访记录",
  "Gattaran_20250610_swWp_JIQH": "已完成RTBO，请联系商家完成合同确认",
  "FoodB_1106_vIQn_DUwT": "已到达最大录制时长{{max_record_time}}秒。是否开始分析？",
  "Internal_Tools_App_phGO_IYRt": "排序",
  "FoodB_management_zycc_XYgy": "输入有误",
  "FoodB_0921__kEaD": "Burn%",
  "FoodC_education_Cancellation_Policy_fxrl": "取消规则",
  "FoodB_email_Cebi_VpDl": "电话",
  "FoodB_Analysis_New_customers_vYDl": "新客",
  "FoodB_up250108_UapS_ZXgM": "立刻查看",
  "Fintech_Credit_2__TvDQ": "撤销原因",
  "Gattaran_202406_UOFx_ekzp": "取消",
  "FoodB_resivion_Overdue_visit_jTHW": "过期拜访",
  "FoodB_calculator_TJJY_SkoH": "商家投入金额",
  "FoodOpB_CRM_Taxpayer_Address_EBwy": "纳税人地址（全国）",
  "FoodC_202408_YjqN_Yvyz": "添加地址后，可查看配送费和配送时长",
  "FoodOpB_analysis_Performance_analysis_NMbA": "绩效数据分析",
  "FoodOpB_set_Determination_wYFG": "确定",
  "FoodC_202408_IMjl_ywFc": "重新定位",
  "Gattaran_System_wrVY_PjDQ": "计划名称",
  "FoodC_202410_pHYX_VjbD": "关闭",
  "FoodB_model20250116_TRTm_agBI": "返回",
  "FoodB_calculator_ydSg_ejbp": "增值税",
  "FoodB_2__FNaI": "同商圈",
  "请输入XXXXX-XXX": "",
  "合同类型": "",
  "回收完成": "回收完成",
  "签约状态": "",
  "正常经营": "正常经营",
  "合作拜访结果": "",
  "执照照片": "",
  "重复门店电话": "",
  "暂无合作意愿": "",
  "日常维护信息": "",
  "签字": "",
  "请选择不合作原因": "",
  "首次完单时间": "",
  "支行号": "",
  "暂无": "",
  "获取商圈中...": "",
  "周四": "",
  "请在Gattaran上完成撤销申请！": "",
  "输入有误": "",
  "设备信息": "",
  "申诉通道": "",
  "目前营业中门店": "",
  "店主（法人）": "店主（法人）",
  "未达到任务完成的标准": "",
  "授权书照片": "",
  "证号": "",
  "法人CPF": "",
  "工具": "",
  "工商登记时间": "",
  "未确定合作": "未确定合作",
  "Curp号必须为18位字符": "",
  "提交成功": "",
  "公司": "",
  "驳回原因": "",
  "城市": "",
  "发放时间": "",
  "商机转交": "",
  "保存并发邮件&短信": "",
  "签约授权书": "",
  "信息已完善": "",
  "上拉加载更多": "",
  "支付验证未通过": "",
  "等待原因": "",
  "平台配送及自配送不允许同时选择不支持": "",
  "平台管控中": "平台管控中",
  "信心度A": "信心度A",
  "信心度B": "信心度B",
  "信心度C": "信心度C",
  "是": "",
  "同意上线": "同意上线",
  "查看更多": "",
  "KP CPF": "",
  "评分": "",
  "法人名片假名": "",
  "我的拜访": "我的拜访",
  "居民证明": "",
  "确认签章": "",
  "合作拜访": "",
  "拜访记录": "",
  "无合作意向": "",
  "PAD型号": "PAD型号",
  "乙方名称片假名": "",
  "开户行": "",
  "点击收起": "",
  "暂停营业中": "暂停营业中",
  "周日": "",
  "已关闭": "",
  "CNPJ": "",
  "KP姓片假名": "",
  "有效": "",
  "CKA BD": "",
  "确定删除吗？": "",
  "日常工具": "",
  "正常": "",
  "掉线中": "掉线中",
  "沟通经营问题（服务管控+店铺装修）": "沟通经营问题（服务管控+店铺装修）",
  "梅斯卡尔酒": "",
  "帐户持有人CPF": "",
  "商户运营": "",
  "菜单照片": "",
  "去设置": "",
  "跟进中": "",
  "销量(单/周)：": "",
  "支持以下哪种支付方式": "",
  "失败号": "",
  "谷歌地图": "",
  "打开浏览器失败": "",
  "银行卡号仅支持数字输入": "",
  "佣金补贴周期": "",
  "沟通新店保护设置": "沟通新店保护设置",
  "公共契约编号": "",
  "首次完成开店检查时间": "",
  "已签约": "",
  "商家概况": "",
  "执行团队": "",
  "未连接到服务器": "",
  "KP CPF照片": "",
  "自配送起送费": "",
  "电话号码不对": "电话号码不对",
  "我知道了": "",
  "考虑中": "考虑中",
  "Curp号": "",
  "已归档": "",
  "是否需要pad": "",
  "点击校准": "",
  "附件照片": "",
  "%s级": "",
  "人工标记平台：": "",
  "审核通过商户数": "",
  "老版无Curp": "",
  "首页": "首 页",
  "商机无效": "",
  "未完成": "未完成",
  "支付验证": "",
  "返回": "",
  "账号无法登陆": "",
  "纳税照片": "",
  "建议拍摄店面照片": "",
  "标题": "",
  "不承诺": "",
  "不能超过%d字": "",
  "佣金补贴比例": "",
  "放弃": "",
  "请选择营业天数": "",
  "KP名": "",
  "单次最大扣费金额": "",
  "持卡人姓": "",
  "请输入门店ID": "",
  "售卖时间": "",
  "是否有异常标签": "",
  "是否有违规记录": "",
  "审批通过": "",
  "上传最大数量为%d张，图片上限为5MB": "",
  "银行代理number": "银行代理number",
  "地区": "",
  "门店logo": "",
  "商家不愿培训": "商家不愿培训",
  "审核中商户数": "",
  "银行": "",
  "已完成设置": "已完成设置",
  "已添加": "",
  "复制成功": "",
  "愿意改善": "愿意改善",
  "首次有效上线时间": "",
  "My Number卡": "My Number卡",
  "设备回收": "设备回收",
  "补充照片": "",
  "再次尝试电话联系": "再次尝试联系",
  "填写拜访": "填写拜访",
  "门店POI不能为空": "",
  "商机信息": "",
  "Pad": "",
  "经营状态": "经营状态",
  "与KP完成沟通即视为有效拜访": "",
  "快速拍摄": "",
  "设备故障": "",
  "菜单信息": "",
  "出生日期": "",
  "自配送费": "",
  "（创建超级管理员账号）": "",
  "请输入": "",
  "法人姓": "",
  "朗姆酒": "",
  "合同记录": "",
  "待办任务": "待办任务",
  "（商家接收邮件）": "",
  "已首次上线商户数": "已首次上线商户数",
  "不想使用外卖模式": "不想使用外卖模式",
  "一般酒精产品贩卖准证": "",
  "请选择": "",
  "营业时间段不能重叠": "营业时间段不能重叠",
  "有特殊情况不能上线": "有特殊情况不能上线",
  "门店PAD信息": "门店PAD信息",
  "商户调研": "商户调研",
  "葡萄酒": "",
  "推迟": "",
  "再次申请": "",
  "自配送佣金比例": "",
  "门店地址": "",
  "推荐完成": "推荐完成",
  "拜访内容": "拜访类型",
  "活期": "",
  "创建时间": "",
  "过期拜访": "过期拜访",
  "刷新成功": "刷新成功",
  "解约": "",
  "价格承诺": "",
  "电子合同": "",
  "KP电话": "",
  "不愿配合": "不愿配合",
  "银行流水单": "",
  "是否需要拍照": "是否需要拍照",
  "请输入13位有效数字": "",
  "LTE": "LTE",
  "PAD领取人": "PAD领取人",
  "银行名称": "",
  "确定": "",
  "金额": "",
  "待领取": "",
  "停止营业": "",
  "合作谈判": "合作谈判",
  "KP姓名:": "",
  "商机详情": "",
  "信息未完善": "",
  "CPF": "",
  "查看": "",
  "证件照片": "",
  "税号": "",
  "促进商户首次上线": "促进商户首次上线",
  "语言": "",
  "登录商户账号": "",
  "未联系到关键目标": "未联系到关键目标",
  "任务类型": "",
  "打款授权书": "",
  "营业时间": "",
  "电话培训": "电话培训",
  "联系不上": "联系不上",
  "编辑商机": "",
  "拜访时间": "拜访日期",
  "纸质合同": "",
  "保存草稿": "",
  "账号": "",
  "接收人": "",
  "円": "",
  "无多余人力(过于繁忙)": "无多余人力(过于繁忙)",
  "预计参加：店铺配置": "预计参加：店铺配置",
  "WIFI": "WIFI",
  "无效": "",
  "应上线商户数": "",
  "结算信息": "",
  "(R$)": "",
  "关于": "",
  "设置": "",
  "担心配送质量": "",
  "数值只能是%s位小数": "",
  "CKA": "",
  "录入合同基础信息": "",
  "未见KP": "",
  "不参加": "不参加",
  "不保存": "",
  "酒精销售许可证": "",
  "手机号": "",
  "疑似KA": "",
  "是否有效拜访": "",
  "完成培训": "完成培训",
  "请输入有效的门店id": "",
  "持卡人姓名": "",
  "系统标记平台：": "",
  "其他": "",
  "人工标记平台": "",
  "品牌名称": "",
  "选择日期": "",
  "必须为%d或%d字": "",
  "重复门店ID": "",
  "工商登记注册地": "",
  "白兰地": "",
  "数据": "数据",
  "复制": "",
  "商户签约": "",
  "乙方邮箱": "",
  "无营业资质": "",
  "活跃程度": "活跃程度",
  "找不到店": "",
  "提交开店申请商户数": "",
  "不合作原因": "",
  "关联品牌名称": "",
  "门店距离": "",
  "门店名称": "",
  "陪访人": "陪访人",
  "银行账户digit": "",
  "营业时间不能重复设置": "营业时间不能重复设置",
  "纳税信息": "",
  "完善以下": "",
  "乙方联系人手机": "",
  "30天后解约": "30天后解约",
  "上传照片不能超过%dMB，请重新上传": "",
  "电话支持字符：数字、英文逗号，录入其他符号，不允许提交": "",
  "您当前的网络环境不太好": "",
  "审核失败": "",
  "模式选择": "",
  "商圈": "",
  "类型": "",
  "启动费太高": "启动费太高",
  "加价限制": "",
  "获得初步意向": "获得初步意向",
  "任务ID": "",
  "不确定合作意向": "不确定合作意向",
  "添加营业时间": "",
  "CNPJ号必须为14位数字": "",
  "请输入半角片假，不能超过48个字符": "",
  "回收pad": "回收pad",
  "商家信息": "",
  "自配送范围及时长": "",
  "市政经营许可证": "",
  "至": "",
  "图片": "",
  "未完善": "未完善",
  "打烊中": "打烊中",
  "菜单": "",
  "下一步": "",
  "正式拜访": "正式拜访",
  "具备上线能力": "",
  "金额(MX$)": "",
  "平台配送最低服务费": "",
  "系统标记平台": "",
  "请选择无效拜访原因": "",
  "过于繁忙": "过于繁忙",
  "日本": "",
  "若证件类型选择“老版无Curp”，需上传补充附件": "",
  "拜访方式": "拜访方式",
  "选择城市": "",
  "退出登录": "",
  "日常提醒商家上线": "日常提醒商家上线",
  "回收未完成": "回收未完成",
  "上传最大数量为1张，图片上限为5M": "",
  "千": "",
  "签约%d周后": "",
  "乙方联系人CPF": "",
  "照片": "照片",
  "法人姓名": "",
  "营业信息": "营业信息",
  "添加电话": "",
  "打开地图失败": "",
  "商家位置": "",
  "开始扣费时间": "",
  "我负责的": "",
  "平台配送": "",
  "KP邮箱": "",
  "封禁": "",
  "合同信息": "",
  "卫生安全通知": "",
  "账号名称": "",
  "现金支付": "",
  "座机": "",
  "乙方联系人CPF照片": "",
  "许可证有效期": "",
  "还在考虑，需要追客": "还在考虑，需要追客",
  "支行名称": "",
  "门店ID": "",
  "提交材料": "",
  "失败原因": "",
  "无法联系到KP": "",
  "授权人": "",
  "手机": "",
  "请输入XXX-XXXX": "",
  "我的新增": "",
  "KP名片假名": "",
  "没联系到": "没联系到",
  "不需要": "",
  "已拜访商机数": "",
  "仅支持数字输入": "",
  "铺设失败": "铺设失败",
  "任务完成": "",
  "复制链接": "",
  "已完成": "",
  "草稿中": "",
  "否": "",
  "商户主体类型": "",
  "经营品类": "",
  "待定": "",
  "完单量": "",
  "担心外卖模式(不想使用外卖模式)": "担心外卖模式(不想使用外卖模式)",
  "乙方注册地址邮编": "",
  "营业执照": "",
  "账户余额：": "",
  "结算信息照片": "",
  "价格信息": "",
  "证件类型": "",
  "威士忌": "",
  "在线": "在线",
  "销售姓名": "",
  "合同照片": "",
  "龙舌兰酒": "",
  "编辑商机成功": "",
  "拜访对象": "拜访对象",
  "营业中": "营业中",
  "请输入数字": "",
  "全部": "",
  "取消订单量": "",
  "电话": "",
  "请输入门店名称搜索": "",
  "当前门店总数": "",
  "已签约商户数": "",
  "日常维护": "",
  "合同版本": "",
  "商机价值": "",
  "联系方式": "联系方式",
  "管控状态：": "",
  "审批中": "",
  "拜访目标": "",
  "门店类型": "",
  "创建成功": "",
  "账户类型": "",
  "KA BD": "",
  "门店名称片假名": "",
  "乙方注册地址片假名": "",
  "对私": "",
  "个人企业": "",
  "订单均价": "",
  "需要完善": "需要完善",
  "撤销申请": "",
  "请先输入门店地址": "",
  "默认": "",
  "请补全营业时间": "",
  "校准POI": "",
  "全部门店": "",
  "不支持": "",
  "暂停经营": "暂停经营",
  "添加营业时间段": "",
  "合同基础信息": "",
  "请输入5位有效数字": "",
  "提交审批后，在审批过程中信息不可修改，是否确认提交？": "",
  "证件号": "",
  "有限责任公司": "",
  "长期有效": "",
  "乙方注册地址": "",
  "饮料店期间限定酒品贩卖准证": "",
  "请录入关闭原因": "请录入关闭原因",
  "土地使用许可证": "",
  "重复门店": "",
  "普通商家": "",
  "距离": "距离",
  "不小于%d": "",
  "不愿完成": "不愿完成",
  "推迟发放": "推迟发放",
  "必须为%d字": "",
  "担心外卖模式": "",
  "当该餐厅存在多个经营者时，此处必须填写合同签署人或授权合同签署人姓名": "",
  "提交成功！": "",
  "未完成PAD发放": "未完成PAD发放",
  "有效商机数": "",
  "无相关信息": "",
  "查看拜访记录": "查看拜访记录",
  "抽佣：": "",
  "删除": "",
  "银行卡号": "",
  "其他信息": "",
  "起始时间": "",
  "预计进行改善": "预计进行改善",
  "不愿改善": "不愿改善",
  "签约数据": "签约数据",
  "登记簿照片": "",
  "电销团队": "",
  "完成时间": "",
  "放弃原因": "",
  "KP电话:": "",
  "完成PAD发放": "完成PAD发放",
  "完成工作": "",
  "提交中": "",
  "营业时间段": "",
  "任务完成标准": "",
  "商户官网": "",
  "门脸照片": "",
  "门店电话:": "",
  "新建商机成功": "",
  "添加拜访计划": "添加拜访计划",
  "营业执照照片": "",
  "驾照": "",
  "个人信息": "",
  "订单量": "",
  "董事": "董事",
  "有效期": "",
  "周三": "",
  "高端饭店": "概念",
  "是否已经加入其他外卖平台？": "",
  "周一": "",
  "点击查看原因": "",
  "去修改": "",
  "KP电话是店长账户": "",
  "确认要清空搜索记录吗？": "",
  "状态机": "",
  "暂无数据": "",
  "拜访详情": "",
  "启动费": "",
  "疑似CKA": "",
  "选择职位": "选择职位",
  "提交人": "提交人",
  "签约信息": "",
  "审核中": "",
  "请输入半角片假名": "",
  "请选择无意愿原因": "",
  "（多选）": "（多选）",
  "上一步": "",
  "周五": "",
  "执行人": "",
  "填写拜访备注可供后续跟进参考": "",
  "扣费次数大于等于1": "",
  "线下": "线下",
  "效率": "效率",
  "无效商机": "无效商机",
  "拜访历史": "",
  "封禁中": "封禁中",
  "原因": "",
  "CPF号必须为11位数字": "",
  "周二": "",
  "保存": "",
  "商户号": "",
  "参加": "参加",
  "万": "",
  "乙方联系方式": "",
  "加价限制（%）": "",
  "上传交付照片": "",
  "商户主体类型为公司时需提供此项内容": "",
  "编辑经营信息": "",
  "开户公司CNPJ": "",
  "门店信息": "",
  "当前数据计算至:": "",
  "店长": "店长",
  "已完成培训": "已完成培训",
  "不限": "",
  "品牌授权书": "",
  "P1": "",
  "请输入3位有效数字": "",
  "P0": "",
  "P2": "",
  "转让": "",
  "自入驻": "",
  "老版有Curp": "",
  "店内环境": "",
  "详细原因": "",
  "金酒": "",
  "请输入7位有效数字": "",
  "签字授权书": "",
  "无效原因": "",
  "持卡人地址": "",
  "拜访备注": "",
  "标记问题门店": "",
  "已完善": "已完善",
  "指定": "",
  "发起者": "",
  "抽佣问题": "",
  "合法代表": "",
  "自定义": "",
  "店铺主体类型是法人时必填（13位数，国税厅公布的法人号码）": "",
  "单次最大扣费金额(MX$)": "",
  "重复门店名称": "",
  "KP姓名": "",
  "IMEI": "IMEI",
  "负责人表示不合作": "负责人表示不合作",
  "去升级": "",
  "将本页截图发送至didi@didichuxing.com;总部进行人工线下校验，并在7日内反馈申诉结果;": "",
  "银行代理digit": "",
  "巴西": "",
  "捡入": "",
  "线上支付": "",
  "竞品独家签约": "",
  "总评价人数": "",
  "周六": "",
  "门店电话": "",
  "标红信息即可完成添加": "",
  "疑似CKA/KA": "",
  "执行者": "",
  "法人CPF照片": "",
  "待办事项": "",
  "预计休业": "预计休业",
  "其他筛选": "其他筛选",
  "是否自配送：": "",
  "当前定位失败": "",
  "优先级": "",
  "任务来源": "",
  "可提现金额：": "",
  "自配送订单量（单/周）": "",
  "审核完成": "",
  "店员": "店员",
  "冻结金额：": "",
  "签约状态：": "",
  "时间格式错误": "",
  "审批失败": "",
  "确定合作": "确定合作",
  "啤酒": "",
  "接收电子合同的邮箱": "",
  "门店照片": "",
  "电话预约": "预约拜访",
  "选择商圈": "",
  "KA": "",
  "结束时间": "",
  "确认银行卡号": "",
  "在留卡": "",
  "访谈&调研": "访谈&调研",
  "承诺": "",
  "实际上线商户数": "",
  "暂不支持复制功能": "",
  "不能为空": "",
  "暂停营业": "",
  "提案失败": "提案失败",
  "经营信息": "",
  "依据门店POI反解": "",
  "拜访结果": "",
  "乙方联系人姓": "",
  "银行卡号必须为18位": "",
  "储蓄": "",
  "首位必须是1，必须输入11位": "",
  "无银行账号": "",
  "KP所属部门": "",
  "成功留存": "成功留存",
  "伏特加": "",
  "暂时不愿上线": "暂时不愿上线",
  "沟通经营问题": "沟通经营问题",
  "支持": "",
  "请输入正确的邮箱地址": "",
  "确认要退出吗？": "",
  "乙方联系人": "",
  "公证编号和地区": "",
  "后续陌拜": "后续陌拜",
  "持卡人名": "",
  "通过时间": "",
  "请输入银行名称或五十音": "",
  "指已签约并且上线接单的门店": "",
  "线下店铺菜单": "",
  "无多余人力": "",
  "格式错误": "",
  "合同生效日期": "",
  "分发失败": "",
  "使用此功能需升级至最新版本": "",
  "任务分发": "",
  "乙方联系人名片假名": "",
  "ESC": "",
  "无法获取手机定位，请检查": "",
  "上传最大数量为3张，图片上限为5M": "",
  "佣金审核证明": "",
  "范围": "",
  "公司公证": "",
  "审核通过": "",
  "查看申请": "",
  "未签约": "",
  "申请签约": "",
  "已校准": "",
  "审核结束": "",
  "具备上线能力商户数": "",
  "邮编": "",
  "手机和座机都只支持10位数字": "",
  "不允许特殊字符": "",
  "KP姓": "",
  "店内桌数（桌）": "",
  "待提交": "",
  "附件说明": "",
  "查看示例": "",
  "工商登记号码": "",
  "去填写": "",
  "待办理": "",
  "账户状态：": "",
  "设备铺设结果": "",
  "上传失败，请重新上传": "",
  "支持上传附件，含关键信息页需单独拍照上传至【执照照片】": "",
  "签约中": "",
  "不需要pad": "",
  "高端饭店不做外卖": "",
  "最多%d个": "",
  "合同编号": "",
  "门店POI": "",
  "开店信息": "",
  "商家开店检查": "",
  "KP电话（仅支持手机）": "",
  "关联签约主体名称": "",
  "法人姓片假名": "",
  "成功": "",
  "开始时间": "",
  "审批邮件": "",
  "门店品类": "",
  "运营数据": "运营数据",
  "新建商机": "",
  "任务基础信息": "",
  "食堂订单量（单/周）": "",
  "新版": "",
  "需要": "",
  "佣金策略合同模板": "",
  "任务详情": "",
  "预计参加：DiDi配置": "预计参加：DiDi配置",
  "请选择等待原因": "",
  "信息尚未保存，是否保存？": "",
  "请选择接收人": "",
  "股份有限公司": "",
  "乙方联系人头衔": "",
  "处理时间": "处理时间",
  "打款": "",
  "资质类型": "",
  "门店价值": "",
  "编辑": "",
  "当前位置距商家": "",
  "商家是否在线：": "商家是否在线：",
  "护照": "",
  "发起验证申请": "",
  "银行账户number": "",
  "请填写真实原因": "",
  "不能超过%d": "",
  "公证日期": "",
  "已签章": "",
  "商户留存措施": "商户留存措施",
  "自配送": "",
  "失败原因详情": "",
  "金额(円)": "",
  "土地使用许可证执照照片": "",
  "签约": "",
  "任务": "",
  "首次完成签约时间": "",
  "当前门店总数=未签约门店+签约中门店+已签约门店": "",
  "上传最大数量为%d张，图片上限为%dM": "",
  "法人名": "",
  "个人": "",
  "确定合作，准备收集资料": "确定合作，准备收集资料",
  "上传最大数量为1张，图片上限为5MB": "",
  "乙方联系方式是超级管理员账户": "",
  "乙方联系人名": "",
  "乙方联系人姓片假名": "",
  "有效在线商户数": "",
  "歇业中": "歇业中",
  "基础信息": "",
  "销售电话": "",
  "重复门店与创建门店的距离": "",
  "门店": "",
  "全部区域": "",
  "拆迁": "",
  "请选择失败原因": "",
  "搜索记录": "",
  "门店地址片假名": "",
  "未添加": "",
  "加载中": "",
  "请输入12位有效数字": "",
  "不愿上线": "不愿上线",
  "CKA/KA BD": "CKA/KA BD",
  "完成电话": "完成电话",
  "乙方名称": "",
  "更新时间": "更新时间",
  "标准合同模板": "",
  "签约状态（多选）": "",
  "12位数，法人登记簿上的号码": "",
  "请在Gattaran查看": "",
  "被授权人证件照片": "",
  "希望解约/回收pad": "希望解约/回收pad",
  "乙方联系方式（仅支持手机）": "",
  "附件类型": "",
  "计划完成设置": "计划完成设置",
  "有合作意向": "",
  "非餐饮": "",
  "附件文件": "",
  "法人信息": "",
  "点击上传": "",
  "扣费次数": "",
  "培训使用方法": "",
  "陌拜": "陌拜",
  "已完成改善": "已完成改善",
  "扣费比例": "",
  "预定上线": "预定上线",
  "没有更多数据了": "没有更多数据了",
  "未知": "",
  "提交": "",
  "填写拜访信息": "",
  "新功能培训": "新功能培训",
  "详细录入规则": "",
  "不再发放": "不再发放",
  "门店详情": "",
  "提交时间": "",
  "登记簿": "",
  "备注": "备注",
  "不在线": "不在线",
  "提交后将无法正常签约": "",
  "铺设成功": "",
  "催促商家首次上线": "催促商家首次上线",
  "对公": "",
  "商户运营价值": "",
  "米": "",
  "创建失败": "创建失败",
  "已核准": "",
  "确认签章时需上传合同附件，请在Gattaran完成确认！": "",
  "提交至审批": "",
  "在线状态：": "在线状态：",
  "资质信息": "",
  "物料发放": "物料发放",
  "姓名": "姓名",
  "Opening Call": "Opening Call",
  "两次银行卡号不一致！": "",
  "取消": "",
  "法人证件": "",
  "门店营业时间": "",
  "无法获取应用版本信息": "",
  "商家位置为": "",
  "Curp号必须为大写字母": "",
  "活动招商": "活动招商",
  "墨西哥": "",
  "资料录入": "资料录入",
  "地区与语言": "",
  "平台配送佣金比例": "",
  "待完成": "",
  "开户公司名": "",
  "选项和输入框不能为空": "选项和输入框不能为空",
  "邮件&短信已发送给商家": "",
  "您提交的无效原因有误，请检查": "",
  "本模块支持上传文件，可至PC端操作": "",
  "确定要验证当前店铺的银行卡号？点击【确定】发起【支付验证】申请": "",
  "发送邮件&短信": "",
  "正常门店": "",
  "设备铺设": "",
  "销售数据": "",
  "请选择无效原因": ""
}